import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FETCH_METRO_AREAS, FETCH_VEHO_ZIPCODES} from "actions/actionTypes";
var async = require('async');
import classNames from 'classnames';
import {v4 as uuidv4}  from 'uuid'
import CreatableSelect from 'react-select/lib/Creatable';

import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import moment from 'moment'
import formatNumbers  from 'util/formatNumbers';
import momentTimeZone from 'moment-timezone'
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'

import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import AdminFulfillmentListTable from 'dashboard/fulfillment/AdminFulfillmentListTable';
import AdminFulfillmentSearchBox from 'dashboard/fulfillment/AdminFulfillmentSearchBox'
import Datetime from 'react-datetime'
import config from  '../../../config';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";

import {Link} from "react-router";
import GoogleMapWithServiceAreas from 'shared/GoogleMapWithServiceAreas'
import {
    unformatPhoneNumber
}  from 'shared/sharedMethods';
import {
     getWarehouseDataByProvinceCode
}  from 'shared/common/sharedFunctions';
 import AdminWorkwavePlanningTable from './AdminWorkwavePlanningTable';
import AdminScheduledDeliveriesTable from "./AdminScheduledDeliveriesTable";
import AdminShippingTable from "./AdminShippingTable";

import { formatImageForBucket } from '../../util/Utils';

var packedOptionsList = [
    {value: 'Plucked', label: 'Plucked'},
    {value: 'unset', label: 'Un-plucked'},
    {value: 'Packed', label: 'Packed'},
]
var screenDataMap = {
    'ChooseDeliverySuggestionScreen': {title: 'Schedule'},
    'EditContactInfoScreen': {title: 'Edit Contacts'},
    'SetDeliveryDateScreen': {title: 'Set Delivery Date'},
    'CreateOrderConfirmationScreen': {title: 'Order created'},
    'EditWorkWavePlanningScreen': {title: 'Edit'},
    'EditScheduledDeliveriesScreen': {title: 'Edit'},
    'EditShippingScreen': {title: 'Edit'},
    'AddOrderScreen': {
        title: (state) => {
            return 'Add ' + _.get(state, 'selectedOrderType', '').toLowerCase() + ' order'
        }
    },
    'UpdateConnectedTransactionsScreen': {
        title: (state) => {
            return _.get(state, 'currentRecord.connectedOrdersAction') == 'combine' ? 'Combine orders' : 'Un-combine orders'
        }
    },
    'RemoveClaimsForTransactions': {
        title: (state) => {
            return 'Claimed Products'
        }
    },
    'AddOrderDetailScreen': {
        title: (state) => {
            return 'Add ' + _.get(state, 'selectedOrderType', '').toLowerCase() + ' order'
        }
    },
    'FulfillFedExOrderScreen': {
        title: (state) => {
            return 'Are you sure you want to fulfill this order?'
        }
    },
}


class AdminFulfillmentPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            center: config.maps.defaultCoordinates,
            showModal: false,
            currentModal: false,
            currentTab: 'DeliverySchedule',
            errors: {},
            sortBy: '',
            searchText: '',
            currentRecord: {},
            currentScreen: 'ChooseDeliverySuggestionScreen',
            adminFulfillment: {
                data: [],
                fetched: false,
                total: 0
            },
        };
        this.geocoder = new google.maps.Geocoder();
        this.filteredServiceAreasForLocation = []
        this.searchBox = null
        this.originalPackageBoxes = []
    };

    componentWillMount() {
        if (!this.props.metroAreas.fetched) {
            var methodData = {
                "success_event": FETCH_METRO_AREAS,
                'endpoint': '/metro-areas',
                'not_display_success_message': true,

            };
            this.props.makeRequest({}, methodData);
        }
        if (!this.props.vehoZipCodes.fetched) {
            var methodData = {
                "success_event": FETCH_VEHO_ZIPCODES,
                'endpoint': '/veho_orders_zipcodes',
                'not_display_success_message': true,

            };
            this.props.makeRequest({}, methodData);
        }
        this.props.makeRequest({Name: 'CommonSettings'}, {
            "endpoint": "/settings",
            'not_display_error_message': true,
        }).then(function (res) {
            this.originalPackageBoxes = _.map(_.get(res.data.data, [0, 'Data', 'PackageBoxes'], {}), item => {
                return {value: item.dimensions, packageProducts: [], label: item.label}
            })
            this.setState({
                'packageBoxes': _.map(_.get(res.data.data, [0, 'Data', 'PackageBoxes'], {}), item => {
                    return {value: item.dimensions, packageProducts: [], label: item.label}
                })
            })
        }.bind(this)).catch(err => {

        });

    }

    getAggregatedData(params) {
        return new Promise((resolve, reject) => {
            var self = this
            var functionsToCall = {};

            functionsToCall['OrderTransactions'] = function (done) {

                return self.props.makeRequest(_.extend({
                    all: true,
                }, params), {
                    'endpoint': '/transactions',
                    'not_display_success_message': true,
                }).then(res => {
                    if (!_.size(res.data.data)) {
                        self.props.displayMessage({
                            'messageType': 'warning',
                            'messageCode': 'Sorry, order not found'
                        });
                        return done({message: 'Sorry, order not found'})
                    }
                    done(null, res.data)
                }).catch(err => {
                    console.log('error', err);
                    done(err)
                });
            }
            functionsToCall['ShopifyOrder'] = function (done) {
                return self.props.makeRequest(_.extend({
                    ShopifyOrders: true,
                    all: true,
                }, params), {
                    'endpoint': '/shopify_orders',
                    'not_display_success_message': true,
                }).then(res => {

                    console.log('res.data', res.data);
                    done(null, res.data)
                }).catch(err => {
                    console.log('error', err);
                    done(err)
                });
            }

            async.parallel(functionsToCall,
                function (err, results) {
                    if (err) {
                        return reject(err)
                    }
                    resolve(results)
                })
        })

    }

    prepareMultipleOrdersScreen(row, currentScreen) {
        var self = this;
        var orderListData = []
        if (currentScreen == 'UpdateConnectedTransactionsScreen') {
            if (_.get(row, 'connectedOrdersAction') == 'combine') {

                var groupedByOrderID = _.groupBy(_.get(row, 'ShopifyCustomerTransactions', []), item => {
                    return item.OrderID
                })
                orderListData = _.map(groupedByOrderID, (orderData, orderID) => {
                    var foundConnectedOrderData = _.find(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), (item) => {
                        return item.ShopifyOrderID == orderID
                    })
                    console.log('foundConnectedOrderData', foundConnectedOrderData);
                    return {
                        orderID: orderID,
                    }
                })
                orderListData.push({orderID: _.get(row, 'SaleData.OrderID')})

            } else if (_.get(row, 'connectedOrdersAction') == 'uncombine') {


                orderListData = _.map(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), (item) => {
                    return {
                        orderID: item.ShopifyOrderID,
                        ConnectedOrderTransactions: _.map(_.get(item, 'Transactions', []), '_id')
                    }
                })

            }
        } else {
            if (_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                orderListData = _.map(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), (item) => {
                    return {
                        orderID: item.ShopifyOrderID,
                        ConnectedOrderTransactions: _.map(_.get(item, 'Transactions', []), '_id')
                    }
                })
            } else {
                orderListData.push({orderID: _.get(row, 'SaleData.OrderID')})
            }


        }
        console.log('orderListData 2', orderListData);
        var functionsToCall = {}

        this.filteredServiceAreasForLocation = []
        _.forEach(orderListData, (orderData) => {
            functionsToCall[orderData.orderID] = function (done) {
                orderData.selectedLocation = false
                self.getAggregatedData({
                    OrderIDs: [orderData.orderID],
                }).then(function (results) {
                    self.prepareOrderDataToDisplay(orderData, results)
                    done(null, orderData)
                }).catch(function (err) {
                    console.log('err', err);
                    done(err)
                })
            }
        })
        async.parallel(functionsToCall,
            function (err, response) {
                if (err) {
                    return;
                }


                if (currentScreen == 'UpdateConnectedTransactionsScreen') {

                    row.OrdersData = orderListData
                    self.setState({
                        showModal: true,
                        currentScreen: currentScreen,
                        currentRecord: row,
                    })
                } else {
                    row.OrdersData = orderListData
                    self.setState({
                        packageBoxes: _.cloneDeep(self.originalPackageBoxes),
                        showModal: true,
                        currentScreen: currentScreen,
                        currentRecord: row,

                    }, () => {
                        if (_.get(row, 'OrdersData.0.shippingAddressMarketName') !== 'shipping_address_outside_available_locations' && currentScreen == 'SetDeliveryDateScreen') {
                            self.geocodeAddress(_.get(row, 'OrdersData.0.shippingAddressString'))
                        }
                    })
                }
            })

    }

    displayOrderDetails(currentScreen, row) {
        console.log('displayOrderDetails', currentScreen);

        var self = this;
        if (!_.get(row, 'SaleData.OrderID')) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Order ID is not available in the record'
            });
        }

        var recordCopy = _.cloneDeep(row)
        recordCopy.selectedLocation = false
        this.filteredServiceAreasForLocation = []


        this.getAggregatedData({
            OrderIDs: [_.get(row, 'SaleData.OrderID')],
        }).then(function (results) {
            self.prepareOrderDataToDisplay(recordCopy, results)

            self.setState({
                packageBoxes: _.cloneDeep(self.originalPackageBoxes),
                showModal: true,
                currentScreen: currentScreen,
                currentRecord: recordCopy,
            }, () => {
                if (recordCopy.shippingAddressMarketName !== 'shipping_address_outside_available_locations' && currentScreen == 'SetDeliveryDateScreen') {
                    self.geocodeAddress(recordCopy.shippingAddressString)
                }
            })
        }).catch(function (err) {
        })

    }

    prepareOrderDataToDisplay(orderData, results) {
        var self = this;

        orderData.ShopifyOrder = _.get(results.ShopifyOrder, 'data.0', {})
        orderData.shippingAddressMarketName = 'shipping_address_na'
        orderData.orderShippingAddress = {}
        // orderData.OrderProducts = _.concat(_.get(results, 'OrderProducts.data'),_.get(results, 'OrderProducts.data'),_.get(results, 'OrderProducts.data'),_.get(results, 'OrderProducts.data'),_.get(results, 'OrderProducts.data'),_.get(results, 'OrderProducts.data'))
        orderData.OrderProducts = _.get(orderData.ShopifyOrder, 'line_items', [])
        orderData.OrderTransactions = _.get(results, 'OrderTransactions.data', [])
console.log('prepareOrderDataToDisplay', orderData  );
        _.forEach(orderData.OrderProducts, (lineItem) => {
            var foundTransaction = _.find(orderData.OrderTransactions, transaction => {

                return lineItem.product_id == _.get(transaction.ProductID, 'ShopifyProductID', 'n/a')
            })

            lineItem.Transaction = foundTransaction
        })


        if (_.get(orderData.OrderTransactions, '0.ShopifyOrderShippingAddress.province_code')) {

            orderData.orderShippingAddress = orderData.shippingAddressToSave = _.get(orderData.OrderTransactions, '0.ShopifyOrderShippingAddress')

            const {province_code = ''} = orderData.orderShippingAddress || {};
            const foundWarehouseLocation = getWarehouseDataByProvinceCode({warehouseData:config.warehouseData,provinceCode:province_code});
            orderData.shippingAddressMarketName = _.get(foundWarehouseLocation, 'MarketName', 'shipping_address_outside_available_locations')

            // orderData.ShippingAddress = _.get(orderData.ShopifyOrder, 'shipping_address.address1', 'n/a') + ' ' + _.get(orderData.ShopifyOrder, 'shipping_address.address2', 'n/a') + ' ' + _.get(orderData.ShopifyOrder, 'shipping_address.city', '') + ', ' + _.get(orderData.ShopifyOrder, 'shipping_address.province_code', '') + ' ' + _.get(orderData.ShopifyOrder, 'shipping_address.zip', '')
            orderData.shippingAddressString = _.get(orderData.orderShippingAddress, 'address1', 'n/a') + ' ' + _.get(orderData.orderShippingAddress, 'address2', '') + ' ' + _.get(orderData.orderShippingAddress, 'city', '') + ', ' + _.get(orderData.orderShippingAddress, 'province_code', '') + ' ' + _.get(orderData.orderShippingAddress, 'zip', '')


            orderData.deliveryMethodAvailableOptions = []
            var zipCodeToMatch = _.get(orderData.orderShippingAddress, 'zip', '').length > 5 ? _.get(_.get(orderData.orderShippingAddress, 'zip', '').match(/^\d{5}/), 0, 'zip code not correct') : _.get(orderData.orderShippingAddress, 'zip', '');
            var foundGBGServiceZipCode = _.find(self.props.metroAreas.data, (item) => {
                return _.includes(_.get(item, 'ZipCodes', []), zipCodeToMatch)
            })
            console.log('zipCodeToMatch', zipCodeToMatch  );
            var foundVehoServiceZipCode = _.includes(self.props.vehoZipCodes.data, zipCodeToMatch)
        // console.log('foundGBGServiceZipCode', foundGBGServiceZipCode  );
            console.log('foundVehoServiceZipCode', zipCodeToMatch, foundVehoServiceZipCode  );
            if (foundVehoServiceZipCode) {
                orderData.deliveryMethodAvailableOptions.push({value: 'Veho', label: 'Veho'})
                orderData.deliverySuggestion = 'Veho'
                orderData.deliveryMethod = 'Veho'
                if (foundGBGServiceZipCode) {
                    orderData.deliveryMethodAvailableOptions.push({value: 'GBG', label: 'GBG'})
                }
                if (_.some(orderData.OrderTransactions, item => {
                        return !_.includes(_.get(item, 'ProductID.ProductTags', []), 'Shipping Options_Shippable')
                    })) {
                    orderData.considerations = 'Unshippable Items'
                } else {
                    orderData.considerations = 'All shippable Items'
                }
            } else if (foundGBGServiceZipCode) {
                orderData.deliveryMethodAvailableOptions.push({value: 'GBG', label: 'GBG'})
                orderData.considerations = 'Outside Veho Delivery Zone'
                orderData.deliverySuggestion = 'GBG'
                orderData.deliveryMethod = 'GBG'
            } else {
                orderData.considerations = 'Out of service zip codes for GBG and Veho'
            }
            console.log(' orderData.deliverySuggestion', orderData.deliverySuggestion);

        } else {
            orderData.shippingAddressString = 'Shipping address not set'
        }

    }

    addOrder() {
        this.setState({
            showModal: true,
            currentScreen: 'AddOrderScreen',
            selectedOrderType: this.state.currentTab == 'Shipping' ? 'Shipping' : 'Delivery'
        });
    }

    changeTab(params) {
        this.setState({
            currentTab: params.currentTab,
            sortBy:'', /* reset sort */
            adminFulfillment: {
                data: [],
                total: 0,
                fetched: false,
            },
        }, function () {
            this.search()
        });


    }


    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},

        });
    }

    // saveRecord() {
    //     var self = this;
    //     this.setState({pending: true});
    //     var formData = this.validateAndGetFormData();
    //     if (!formData) {
    //         this.setState({pending: false});
    //         return false;
    //     }
    //     var methodData = {
    //         "endpoint": "/settings/" + encodeURIComponent(this.state.currentRecord._id),
    //         type: "patch",
    //     };
    //
    //     self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
    //         self.setState({pending: false});
    //
    //         self.search()
    //         self.closeModal()
    //     }).catch(err => {
    //         self.setState({pending: false});
    //     });
    // }


    onSortChange(field, sort) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sort == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        // if (this.state.pending){
        //     return this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'Please wait till search request is completed'
        //     });
        // }
        this.setState({pending:true})
        var self = this, queryParams = {}

        if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        }
        _.extend(queryParams, params);
        console.log('queryParams', queryParams  );

        if (!_.get(queryParams, 'Markets.0')) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, select a location'
            });
        }
     //   queryParams.perPage = 2;/* revert*/
        queryParams.addFields = ['FulfillByDate']
        if (_.isUndefined(queryParams.Statuses)){
            queryParams.Statuses = ['Pending']
        }

        queryParams.lookup = ['Sellers', 'Users', 'allOrderTransactions', 'allOrderProductsImages', 'ConnectedTransactionsRecords']
        queryParams.orderTransactionsCustomerQuery ={
            Status:{$nin:['Returned', 'Restocked', 'Cancelled']}
        }
        queryParams.fromCreateTime = moment().subtract(30, 'days').toISOString()
        if (config.getEnvironmentName() == 'local'){
            queryParams.fromCreateTime = moment().subtract(90, 'days').toISOString()
        }
        var searchData = {}
        if (this.state.currentTab == 'DeliverySchedule') {
            searchData.OrderShippingType = ['Delivery']
            queryParams.lookup.push('ShopifyCustomerTransactions')
            queryParams.ShopifyCustomerTransactionsQuery = JSON.stringify(
                {
                  "WorkWaveEventID": {"$exists": false},
                 "VehoOrderID": {"$exists": false},
                    Status:'Pending',
                    'SaleData.OrderShippingType':   '#field_2#',
                     'ShopifyOrderShippingAddress.address1':  '#field_3#',
                    'ShopifyOrderShippingAddress.zip': '#field_4#',
                    "createdAt": {$gt: '#date_1#'}


                })
            queryParams.ShopifyCustomerTransactionsQueryData = JSON.stringify({
                '#date_1#': moment().subtract(config.getEnvironmentName() == 'local' ? 90 : 30, 'days').toISOString(),
                '#field_2#': {path:['SaleData','OrderShippingType']},
                '#field_3#': {path:'ShopifyOrderShippingAddress.address1'},
                '#field_4#': {path:'ShopifyOrderShippingAddress.zip'},

            })

            queryParams.customQueries = JSON.stringify([
                {
                    "$match": {
                        "WorkWaveEventID": {"$exists": false},
                        "VehoOrderID": {"$exists": false}
                    }

                }
            ])
        } else if (this.state.currentTab == 'Shipping') {
            if (_.includes(queryParams.Statuses,'Fulfilled')) {

                queryParams.Statuses = []
                queryParams.customQueriesData = {
                    '#date_1#': moment().subtract(10, 'days').startOf('day').toISOString()
                }
                var customQueries = [

                    {
                        "$match": {
                            $or: [
                                {"Status": 'Pending'},
                                {"FulfilledAt": {$gt: '#date_1#'}}

                            ]
                        }
                    }]

                queryParams.customQueries = JSON.stringify(customQueries)
            }
            searchData.OrderShippingType = ['Shipping']
            queryParams.lookup.push('ShopifyCustomerTransactions')
            queryParams.ShopifyCustomerTransactionsQuery = JSON.stringify(
                {
                    "WorkWaveEventID": {"$exists": false},
                    "VehoOrderID": {"$exists": false},
                    Status:'Pending',
                    'SaleData.OrderShippingType':   '#field_2#',
                    'ShopifyOrderShippingAddress.address1':  '#field_3#',
                    'ShopifyOrderShippingAddress.zip': '#field_4#',
                    "createdAt": {$gt: '#date_1#'}


                })
            queryParams.ShopifyCustomerTransactionsQueryData = JSON.stringify({
                '#date_1#': moment().subtract(config.getEnvironmentName() == 'local' ? 90 : 30, 'days').toISOString(),
                '#field_2#': {path:['SaleData','OrderShippingType']},
                '#field_3#': {path:'ShopifyOrderShippingAddress.address1'},
                '#field_4#': {path:'ShopifyOrderShippingAddress.zip'},

            })
        } else if (this.state.currentTab == 'WorkWavePlanning') {

            queryParams.lookup.push('WorkWaveEventID')
            queryParams.customQueries = JSON.stringify([
                {
                    "$match": {
                        "WorkWaveEventID": {"$exists": true},
                        "SaleData.OrderDeliveryDate": {"$exists": false}
                    }

                }
            ])

        } else if (this.state.currentTab == 'ScheduledDeliveries') {
            queryParams.lookup.push('WorkWaveEventID')
            var orQueries = [
                {"SaleData.OrderDeliveryDate": {"$exists": true}},
                {"VehoOrderID": {"$exists": true}}
            ]
            if (_.size(_.get(queryParams, 'deliveryMethods', [])) == 1) {
                console.log('size 1', _.get(queryParams, 'deliveryMethods.0'));
                if (_.get(queryParams, 'deliveryMethods.0') == 'Veho') {
                    _.pullAt(orQueries, 0)
                } else if (_.get(queryParams, 'deliveryMethods.0') == 'GBG') {
                    _.pullAt(orQueries, 1)
                }

            }
            // queryParams.Statuses = ['Pending','Sold']
            queryParams.Statuses = []
            queryParams.customQueriesData = {
                '#date_1#': moment().subtract(3, 'days').startOf('day').toISOString()
            }
            var customQueries = [
                {"$match": {$or: orQueries}},
                {
                    "$match": {
                        $or: [
                            {"Status": 'Pending'},
                            {"FulfilledAt": {$gt: '#date_1#'}}

                        ]
                    }
                }]

            queryParams.customQueries = JSON.stringify(customQueries)
        }
        console.log('searchData', searchData);
        _.extend(queryParams, searchData);
        //   queryParams.fulfillment_status = 'unfulfilled'

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'SaleData.OrderNumber' + ':' + (1);
            // if (this.state.currentTab == 'Shipping') {
            //     queryParams.sortBy = 'FedexShippingData.MasterTrackingNumber' + ':' + (1);
            // }
        }
        queryParams.groupByOrders = 'GroupByTransactionsConnectionID'


        queryParams.searchTextAdditionalFields = ['ShopifyOrderShippingAddress.address1',
            'ShopifyOrderShippingAddress.city',
            'ShopifyOrderShippingAddress.phone',
            'ShopifyOrderShippingAddress.province',
            'ShopifyOrderShippingAddress.zip',
            'ShopifyOrderShippingAddress.province_code']

        queryParams.Types = ['Sale']
        queryParams.doNotLookupProducts = true
        //  queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */

        var methodData = {
            'endpoint': '/transactions',
            timeout: 25000,

        };
        const stringified = queryString.stringify(_.omit(queryParams, ['Types','ShopifyCustomerTransactionsQuery','' +
        'ShopifyCustomerTransactionsQueryData', 'deliveryMethods', 'OrderDeliveryDateExists', 'customQueries', 'searchTextAdditionalFields', 'groupByOrders', 'lookup', 'Statuses', 'doNotLookupProducts', 'sortBySecondary']));
        this.context.router.push('/admin/fulfillment?' + stringified);
        var functionsToCall = {
            // getTransactionsGroupedByOrder: function (done) {
            //     var queryParamsCopy = _.cloneDeep(queryParams)
            //     queryParamsCopy.groupByCustomField = 'SaleData.OrderID'
            //     queryParamsCopy.groupByOperator = 'addToSet'
            //     queryParamsCopy.all = true
            //     return done(null, [])
            //
            //     self.props.makeRequest(queryParamsCopy, methodData).then((res) => {
            //         done(null, res.data)
            //     }).catch(err => {
            //         console.log('err', err);
            //         done(err)
            //     })
            // },
            getTransactions: function (done) {
                var methodDataCopy = _.cloneDeep(methodData)
                // queryParams.customQueries =  JSON.stringify([
                //     {"$group":{
                //         "_id":{"OrderID":"$SaleData.OrderID"},
                //         "Transactions":{"$push":{"_id":"$_id","Amount":"$Amount","SaleData":"$SaleData"}}}}
                //
                // ])
                // return done(null,  [])
                self.props.makeRequest(queryParams, methodDataCopy).then((res) => {

                    self.setState({pending:false})
                    done(null, res.data)
                }).catch(err => {
                    self.setState({pending:false})
                    console.log('err 2', err);
                    done(err)
                })
            },
        }

        async.parallel(functionsToCall,
            function (err, response) {

                self.setState({
                    adminFulfillment: {
                        data: response.getTransactions.data,
                        total: response.getTransactions.total, //_.get(response.getTransactionsGroupedByOrder.data, '0.total',[]).length,
                        fetched: true,
                    }
                })
                if (self.refs.pagination && _.isUndefined(queryParams.page)) {
                    self.refs.pagination.resetPagination();
                }
            })
    }

    mapAddressSelectionCallback(params) {
        console.log('mapAddressSelectionCallback', params);
    }

    geocodeAddress(address) {
        console.log('geocodeAddress', address);
        this.geocoder.geocode({
            'address': address
        }, (results, status) => {
            console.log('results,status', results, status);
            if (status === google.maps.GeocoderStatus.OK) {
                var dataToUpdate = {
                    center: results[0].geometry.location,
                    selectedLocation: {
                        position: results[0].geometry.location,
                        defaultAnimation: 2,
                        key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
                    },
                }
                console.log('dataToUpdate', dataToUpdate);
                this.setState({
                    'currentRecord': {
                        ...this.state.currentRecord,
                        ...dataToUpdate
                    }
                })
            }
        })
    }

    updateLocationData(params) {
        console.log('updateLocationData', params);
        if (_.size(params.serviceAreasForLocation) > 0) { /* it can be passed as empty array in mapAddressSelectionCallback */
            this.filteredServiceAreasForLocation = _.map(params.serviceAreasForLocation, serviceArea => _.extend({}, serviceArea, {available: true}));
            if (this.filteredServiceAreasForLocation.length) {
                var dataToUpdate = {

                    // ServiceAreaNames:  this.filteredServiceAreasForLocation[0].Name,

                }
                this.setState({
                    'currentRecord': {
                        ...this.state.currentRecord,
                        ...dataToUpdate
                    }

                })
            }
        }
    }

    renderOrderComments() {
        return <div><span className="purple text-center">Comments</span>
            {_.map(_.get(this.state.currentRecord, 'SaleData.ShopifyOrderComments', []), (comment, index) => {
                return <div
                    className={'pleft15 top6'}
                    key={index}>
                <span
                >{comment.Message}</span>
                </div>
            })}
        </div>
    }

    displayChangeStatusFieldForProduct(item) {

        var displayOnly = false,
            specificOrderTransactionsDataToUpdate = _.get(this.state.currentRecord, 'specificOrderTransactionsDataToUpdate', {})
        var initialProductState = _.get(item, 'Transaction.SaleData.ProductState', 'unset')
        if (_.get(specificOrderTransactionsDataToUpdate, [_.get(item, 'Transaction._id'), 'ProductState'])) {
            var currentProductState = _.get(specificOrderTransactionsDataToUpdate, [_.get(item, 'Transaction._id'), 'ProductState'])
            console.log('currentProductState 2', currentProductState);
        }else{
            var currentProductState =initialProductState
        }
        if (_.get(this.searchBox, 'state.filterOptions.Market')) {
            var MarketNameToCheck =_.get(config.warehouseData[_.get(item, 'Transaction.MarketName')],'FulfillmentCenter', _.get(item, 'Transaction.MarketName', ''))
            console.log('MarketNameToCheck', MarketNameToCheck  );
            if (MarketNameToCheck !== _.get(this.searchBox, 'state.filterOptions.Market')) {

                displayOnly = true;
            }
        }

        return <div>

            <FormGroup>

                {displayOnly ?
                    <div
                        className="font-size-20">{_.get(_.find(packedOptionsList, {value: currentProductState}), 'label', 'n/a')}</div> :
                    <Select
                        tabIndex="0"
                        placeholder="Plucked"
                        clearable={false}
                        options={packedOptionsList}
                        onChange={ (option) => {
                            console.log('option', option);

                            if (option && currentProductState !== option.value) {

                                var specificOrderTransactionsDataToUpdate = _.get(this.state.currentRecord, 'specificOrderTransactionsDataToUpdate', {})
                                if (specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')]) {
                                    if(initialProductState== option.value){
                                        delete specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')]['ProductState']
                                        if (_.isEmpty(specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')])){
                                            delete specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')]
                                        }
                                    }else {
                                        specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')]['ProductState'] = option.value
                                    }
                                } else {
                                    specificOrderTransactionsDataToUpdate[_.get(item, 'Transaction._id')] = {
                                        ProductState: option.value,
                                        //TransactionRecord:_.get(item, 'Transaction'),
                                    }
                                }
                                this.setState({
                                    'currentRecord': {
                                        ...this.state.currentRecord,
                                        specificOrderTransactionsDataToUpdate: specificOrderTransactionsDataToUpdate
                                    }
                                })
                            }

                        }}
                            value={currentProductState}/>}
                    </FormGroup>
                    </div>
                }
    displayChangeStatusField(currentProductState) {

        return <div>
            <Row className='top30 bot30'>
                <Col xs={12} md={12} sm={12} lg={12}>
                    <span className="text-bold  purple right5">Address: </span>
                    <span
                        className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                </Col>
            </Row>
            <FormGroup>
                <ControlLabel>Status</ControlLabel>
                <Select
                    tabIndex="0"
                    placeholder="Plucked"
                    clearable={false}
                    options={packedOptionsList}
                    onChange={ (option) => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                ProductState: option ? option.value : null
                            }
                        })
                    }}
                    value={currentProductState}/>
            </FormGroup>
        </div>
    }

    displayCurrentScreenContent() {
        var self = this;
        
         if (this.state.currentScreen == 'VehoScreen') {
            var productsAddedToPackages = _.reduce(_.get(this.state.currentRecord, 'selectedPackages', []), function (total, selectedPackage) {
                total += _.get(selectedPackage, 'packageProducts', []).length

                return total
            }, 0)
            var allAvailableProducts = _.reduce(_.get(this.state.currentRecord, 'OrdersData', []), function (ordersTotal, orderData) {
                var orderProductsTotal = _.reduce(_.get(orderData, 'OrderProducts', []), function (total, product) {
                    if (_.get(self.searchBox, 'state.filterOptions.Market')) {
                        var MarketNameToCheck =_.get(config.warehouseData[_.get(product, 'Transaction.MarketName')],'FulfillmentCenter', _.get(product, 'Transaction.MarketName', ''))
                        if (MarketNameToCheck !== _.get(self.searchBox, 'state.filterOptions.Market')) {
                            return total
                        }
                    }
                    if (_.get(product, 'Transaction.FulfilledAt')) {
                        return total
                    }
                    if (_.get(product, 'Transaction.Status') !== 'Pending') {
                        return total
                    }
                    if (!_.get(product, 'Transaction._id')) {
                        return total
                    }
                    if (_.size(_.get(orderData, 'ConnectedOrderTransactions', [])) && !_.includes(orderData.ConnectedOrderTransactions, _.get(product, 'Transaction._id'))) {
                        return total
                    }
                    return total + 1
                }, 0)
                return ordersTotal + orderProductsTotal
            }, 0)
            console.log('allAvailableProducts', allAvailableProducts);
             console.log('productsAddedToPackages', productsAddedToPackages);

        }
        if (this.state.currentScreen == 'GBGScreen') {
            return <div>
                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Address: </span>
                        <span
                            className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                    </Col>
                </Row>
                <Row className="left0 top30">
                    <Col md={12} sm={12} xs={12} className="pleft0 top30 bot20">
                        <Button style={{width: '300px'}} className="btn btn-lg btn-primary"
                                disabled={ this.state.pending || _.isUndefined(_.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.province_code'))}
                                onClick={(e) => {
                                    var self = this;
                                    if (!this.state.pending) {
                                        this.createWorkWaveOrder().then(function (response) {
                                            return self.updateOrderTransactions({
                                                dataToUpdate: {
                                                    WorkWaveEventID: response.data._id
                                                }
                                            }).then(function (response) {
                                                self.search()
                                                self.setState({pending: false});
                                                self.closeModal()
                                            })
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })
                                    }
                                }
                                }>
                            Send To WorkWave
                        </Button>
                    </Col>

                    <Col md={12} sm={12} xs={12} className="top30 bot30 pleft0">
                        <Button className="btn btn-default"
                                onClick={(e) => this.setState({
                                    currentScreen: 'ChooseDeliverySuggestionScreen'
                                })}>
                            Back
                        </Button>
                    </Col>

                </Row>
            </div>
        } else if (this.state.currentScreen == 'VehoScreen') {
            return <div>
                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Address: </span>
                        <span
                            className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={6} className="top20">

                        <CreatableSelect
                            clearable={false}
                            multi
                            placeholder="Package Size"

                            promptTextCreator={(inputValue) => {
                                return 'Add package as H W L ' + inputValue
                            }}
                            options={this.state.packageBoxes}
                            onChange={ (selectedOptions) => {
                                console.log('selectedOptions', selectedOptions);
                                if (_.find(selectedOptions, option => {
                                        console.log('option', option)
                                        if (_.get(option, 'className')) {
                                            var match = _.trim(option.value).match(/^(\d+)[^\d]+(\d+)[^\d]+(\d+)$/)
                                            console.log('match', match);
                                            if (!match) {
                                                return true
                                            } else {
                                                option.value = [match[1], match[2], match[3]]
                                            }

                                        }
                                    })) {
                                    return this.props.displayMessage({
                                        'messageType': 'warning',
                                        'messageCode': 'New option must have a format like this: H W L'
                                    });
                                }
                                var selectedOptionsCopy = _.map(selectedOptions, item => {
                                    if (!_.size(item.packageProducts)) {
                                        item.id = uuidv4()
                                        /* give new id to the option*/
                                        if (_.get(item, 'className')) {
                                            item.packageProducts = []
                                        }
                                    }

                                    return _.cloneDeep(item)
                                    /* clone selected options, so that original packageBox objects are not updated */

                                })
                                this.setState({
                                    currentRecord: {
                                        ...this.state.currentRecord,
                                        currentSelectedPackageID: _.size(selectedOptionsCopy) ? _.last(selectedOptionsCopy).id : false,
                                        'selectedPackages': selectedOptionsCopy
                                    }
                                })
                            }}
                            value={_.get(this.state.currentRecord, 'selectedPackages', [])}
                        />
                    </Col>
                </Row>
                {  this.displaySelectedPackagesToProductsMap()}
                <Row className="left0 top30">
                    <Col md={12} sm={12} xs={12} className="pleft0 top10 bot10">
                        <Button style={{width: '300px'}} className="btn btn-lg btn-primary"
                                disabled={ this.state.pending || productsAddedToPackages == 0 || allAvailableProducts !== productsAddedToPackages}
                                onClick={ () => {
                                    var self = this;
                                    if (!this.state.pending) {
                                        self.createVehoOrder().then(function (VehoOrderResponse) {
                                            console.log('VehoOrderResponse', VehoOrderResponse);
                                            var specificTransactionsDataToUpdate = {}
                                            _.forEach(VehoOrderResponse.VehoOrderPackageData, packageData => {
                                                _.forEach(packageData.TransactionIDs, transactionID => {
                                                    /*   transaction can be linked to only one package*/
                                                    var foundPackageData = _.find(VehoOrderResponse.VehoOrderData.packages, responsePackage => {
                                                        return responsePackage.externalId == packageData.externalId
                                                    })
                                                    console.log('foundPackageData', foundPackageData);
                                                    specificTransactionsDataToUpdate[transactionID] = {
                                                        VehoOrderData: {
                                                            PackageHeight: _.get(packageData, 'height', '0'),
                                                            PackageWidth: _.get(packageData, 'width', '0'),
                                                            PackageLength: _.get(packageData, 'length', '0'),
                                                            PackageID: _.get(foundPackageData, '_id', 'n/a'),
                                                            TrackingID: _.get(foundPackageData, 'trackingId', 'n/a'),
                                                            BarCode: _.get(foundPackageData, 'barCode', 'n/a'),
                                                        }
                                                    }
                                                })
                                            })
console.log('specificTransactionsDataToUpdate', specificTransactionsDataToUpdate  );

                                            return self.updateOrderTransactions({
                                                dataToUpdate: {
                                                    VehoOrderID: _.get(VehoOrderResponse, 'VehoOrderData._id'),
                                                },
                                                specificTransactionsDataToUpdate: specificTransactionsDataToUpdate,
                                                transactionsToUpdate: _.map(specificTransactionsDataToUpdate, (value, transactionID) => {
                                                    return {_id: transactionID}
                                                })

                                            }).then(function () {
                                                return self.fulfillOrdersWithVehoData(VehoOrderResponse).then(function () {
                                                    self.setState({
                                                        currentRecord: {
                                                            ...self.state.currentRecord,
                                                            VehoOrderData: _.get(VehoOrderResponse, 'VehoOrderData'),
                                                            VehoOrderPackageData: _.get(VehoOrderResponse, 'VehoOrderPackageData'),
                                                        },
                                                        pending: false,
                                                        currentScreen: 'CreateOrderConfirmationScreen'
                                                    }, () => {
                                                        self.search()
                                                    })

                                                })
                                            })
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })
                                    }
                                }}
                        >
                            Schedule Veho Delivery
                        </Button>

                    </Col>
                    {this.state.currentTab === 'DeliverySchedule' &&
                    <Col md={12} sm={12} xs={12} className="top30 pleft0 bot20">
                        <Button className="btn btn-default"
                                onClick={(e) => this.setState({
                                    currentScreen: 'ChooseDeliverySuggestionScreen'
                                })}>
                            Back
                        </Button>
                    </Col>
                    }
                </Row>
            </div>
        } else if (this.state.currentScreen == 'ChooseDeliverySuggestionScreen') {
            return <div>
                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Address: </span>
                        <span
                            className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                    </Col>
                </Row>

                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold purple right5">Delivery Suggestion:</span>
                        <span
                            className="  font-size-18">{_.get(this.state.currentRecord, 'OrdersData.0.deliverySuggestion', '') } </span>
                    </Col>
                </Row>
                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Considerations:</span>
                        <span
                            className="font-size-18">{_.get(this.state.currentRecord, 'OrdersData.0.considerations', '') } </span>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={6} style={{maxWidth: 300}} className="top20">
                        <Select
                            tabIndex="0"
                            placeholder="Delivery Method"
                            clearable={false}
                            options={ _.get(this.state.currentRecord, 'OrdersData.0.deliveryMethodAvailableOptions', [])}
                            onChange={ (option) => {
                                this.setState({
                                    'currentRecord': {
                                        ...this.state.currentRecord,
                                        deliveryMethod: option ? option.value : null
                                    }
                                })
                            }}
                            value={_.get(this.state.currentRecord, 'deliveryMethod', _.get(this.state.currentRecord, 'OrdersData.0.deliveryMethod')) }/>
                    </Col>
                </Row>
                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button className=" right0 pull-left btn btn-primary "
                                disabled={!_.get(this.state.currentRecord, 'deliveryMethod', _.get(this.state.currentRecord, 'OrdersData.0.deliveryMethod'))}
                                type="button"
                                onClick={ () => {
                                    this.setState({currentScreen: _.get(this.state.currentRecord, 'deliveryMethod', _.get(this.state.currentRecord, 'OrdersData.0.deliveryMethod')) + 'Screen'})
                                }}> Continue
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen == 'EditContactInfoScreen') {
            return <div>
                <Checkbox className="top30"
                         // disabled={true}
                          onClick={() => {
                              var packageForPickup = {
                                  id: uuidv4(),
                                  packageProducts: [],
                                  label: 'Products for pickup'
                              }
                              this.setState({
                                  'currentRecord': {
                                      ...this.state.currentRecord,
                                      currentSelectedPackageID: packageForPickup.id,
                                      'selectedPackages': [packageForPickup],
                                      changeShippingTypeToPickup: !this.state.currentRecord.changeShippingTypeToPickup
                                  }
                              })
                          }}
                          checked={this.state.currentRecord.changeShippingTypeToPickup}>Change shipping type to
                    Pickup</Checkbox>

                {_.size(_.get(this.state.currentRecord, 'SaleData.ShopifyOrderComments', []))>0&& this.renderOrderComments()}
                {!this.state.currentRecord.changeShippingTypeToPickup &&
                <div>
                    <Row className='top10 bot20'>
                        <Col xs={12} md={12} sm={12} lg={12} className="top15">
                            <span className="text-bold  purple right5  ">Address: </span>
                            <span
                                className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                        </Col>
                    </Row>
                    <FormGroup>
                        <ControlLabel>Street Address 1</ControlLabel>
                        <FormControl type="text"
                                     onChange={(e) => this.setState({
                                         'currentRecord': {
                                             ...this.state.currentRecord,
                                             shippingAddressToSave: {
                                                 ...this.state.currentRecord.shippingAddressToSave,
                                                 address1: e.target.value
                                             }
                                         }
                                     })}
                                     value={_.get(this.state.currentRecord, 'shippingAddressToSave.address1', _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.address1', '')) }
                        />
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Street Address 2</ControlLabel>
                        <FormControl type="text"
                                     onChange={(e) => this.setState({
                                         'currentRecord': {
                                             ...this.state.currentRecord,
                                             shippingAddressToSave: {
                                                 ...this.state.currentRecord.shippingAddressToSave,
                                                 address2: e.target.value
                                             }
                                         }
                                     })}
                                     value={_.get(this.state.currentRecord, 'shippingAddressToSave.address2', _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.address2', '')) }
                        />
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>City</ControlLabel>
                        <FormControl type="text"
                                     onChange={(e) => this.setState({
                                         'currentRecord': {
                                             ...this.state.currentRecord,
                                             shippingAddressToSave: {
                                                 ...this.state.currentRecord.shippingAddressToSave,
                                                 city: e.target.value
                                             }
                                         }
                                     })}

                                     value={_.get(this.state.currentRecord, 'shippingAddressToSave.city', _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.city', '')) }
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>State code</ControlLabel>
                        <FormControl type="text"
                                     onChange={(e) => this.setState({
                                         'currentRecord': {
                                             ...this.state.currentRecord,
                                             shippingAddressToSave: {
                                                 ...this.state.currentRecord.shippingAddressToSave,
                                                 province_code: e.target.value
                                             }
                                         }
                                     })}

                                     value={_.get(this.state.currentRecord, 'shippingAddressToSave.province_code', _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.province_code', '')) }
                        />
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Zip code</ControlLabel>
                        <FormControl type="text"
                                     onChange={(e) => this.setState({
                                         'currentRecord': {
                                             ...this.state.currentRecord,
                                             shippingAddressToSave: {
                                                 ...this.state.currentRecord.shippingAddressToSave,
                                                 zip: e.target.value
                                             }
                                         }
                                     })}

                                     value={_.get(this.state.currentRecord, 'shippingAddressToSave.zip', _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress.zip', '')) }
                        />
                    </FormGroup>
                </div>
                }
                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button className=" right0 pull-left btn btn-primary "
                            //     disabled={!_.size(this.state.deliveryMethod)}
                                type="button"
                                onClick={ () => {
                                    var self = this
                                    if (!this.state.pending) {
                                        if (this.state.currentRecord.changeShippingTypeToPickup) {

                                        } else {
                                            this.updateShopifyOrders().then(function (dataToUpdate) {
                                                return self.updateOrderTransactions({dataToUpdate: dataToUpdate}).then(function () {
                                                    console.log('update');

                                                    self.search()
                                                    self.setState({pending: false});
                                                    self.closeModal()
                                                })
                                            }).catch(err => {
                                                self.setState({pending: false});
                                            })
                                        }

                                    }

                                }}>{this.state.currentRecord.changeShippingTypeToPickup ? 'Change to Pickup' : 'Update'}
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen == 'EditWorkWavePlanningScreen') {
            return <div>
                <Checkbox
                    onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                removeWorkWaveEventID: !this.state.currentRecord.removeWorkWaveEventID
                            }
                        })
                    }}
                    checked={this.state.currentRecord.removeWorkWaveEventID}>Remove WorkWave order</Checkbox>
                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button className=" right0 pull-left btn btn-primary "
                                disabled={_.isEmpty(_.get(this.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}))
                              // && currentProductState == initialProductStateValue
                                && !this.state.currentRecord.removeWorkWaveEventID }
                                type="button"
                                onClick={ () => {
                                    var self = this
                                    if (!this.state.pending) {
                                        var dataToUpdate = {}
                                        // if (currentProductState !== initialProductStateValue) {
                                        //     dataToUpdate.ProductState = this.state.currentRecord.ProductState
                                        // }
                                     
                                        if (this.state.currentRecord.removeWorkWaveEventID) {
                                            dataToUpdate.WorkWaveEventID = 'unset';
                                            dataToUpdate.OrderDeliveryDate = 'unset';
                                        }
                                        this.removeWorkWaveOrder(dataToUpdate).then(function (response) {
                                            var data = {dataToUpdate: dataToUpdate}
                                            if (!_.isEmpty(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}))) {
                                                data.specificTransactionsDataToUpdate =_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{})
                                                data.transactionsToUpdate = _.map(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}), (value, transactionID) => {
                                                    return {_id: transactionID}
                                                })
                                            }
                                            console.log('data', data  );
                                            return self.updateOrderTransactions(data).then(function (response) {
                                                self.search()
                                                self.setState({pending: false});
                                                self.closeModal()
                                            })
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })

                                    }

                                }}> Update
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen == 'EditScheduledDeliveriesScreen') {
             var GBGServiceIsAvailable = _.find(_.get(this.state.currentRecord, 'OrdersData.0.deliveryMethodAvailableOptions'), {value: 'GBG'})
            var VehoServiceIsAvailable = _.find(_.get(this.state.currentRecord, 'OrdersData.0.deliveryMethodAvailableOptions'), {value: 'Veho'})
            return <div>


                { _.get(this.state.currentRecord, 'WorkWaveEventID') &&
                <Checkbox
                    disabled={  !VehoServiceIsAvailable}
                    onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                changeToVeho: !this.state.currentRecord.changeToVeho,
                                unsetOrderDeliveryDate: !this.state.currentRecord.changeToVeho ? true : this.state.currentRecord.unsetOrderDeliveryDate
                            }
                        })
                    }}
                    checked={this.state.currentRecord.changeToVeho}>{VehoServiceIsAvailable ? 'Change to Veho' : 'Outside Veho Delivery Zone'}</Checkbox>
                }
                { _.get(this.state.currentRecord, 'WorkWaveEventID') &&
                <Checkbox
                    disabled={this.state.currentRecord.changeToVeho}
                    onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                unsetOrderDeliveryDate: !this.state.currentRecord.unsetOrderDeliveryDate
                            }
                        })
                    }}
                    checked={this.state.currentRecord.unsetOrderDeliveryDate}>Send back to WorkWave</Checkbox>
                }
                { _.get(this.state.currentRecord, 'VehoOrderID') &&
                <Checkbox
                    disabled={  !GBGServiceIsAvailable}
                    onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                changeToGBG: !this.state.currentRecord.changeToGBG,
                                cancelVehoOrder: !this.state.currentRecord.changeToGBG ? true : this.state.currentRecord.cancelVehoOrder
                            }
                        })
                    }}
                    checked={this.state.currentRecord.changeToGBG}>{GBGServiceIsAvailable ? 'Change to GBG' : 'Outside GBG Delivery Zone'}</Checkbox>
                }
                { _.get(this.state.currentRecord, 'VehoOrderID') &&
                <Checkbox
                    disabled={this.state.currentRecord.changeToGBG}
                    onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                cancelVehoOrder: !this.state.currentRecord.cancelVehoOrder
                            }
                        })
                    }}
                    checked={this.state.currentRecord.cancelVehoOrder}>Cancel Veho order</Checkbox>
                }
                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button className=" right0 pull-left btn btn-primary "
                                disabled={this.state.pending || !( !_.isEmpty(_.get(this.state.currentRecord,'specificOrderTransactionsDataToUpdate',{})) ||
                               // currentProductState !== initialProductStateValue ||
                                this.state.currentRecord.changeToGBG || this.state.currentRecord.cancelVehoOrder || this.state.currentRecord.changeToVeho || this.state.currentRecord.unsetOrderDeliveryDate)}
                                type="button"
                                onClick={ () => {
                                    var self = this
                                    if (!this.state.pending) {

                                        // if (currentProductState !== initialProductStateValue) {
                                        //     dataToUpdate.ProductState = this.state.currentRecord.ProductState
                                        // }
                                        var data = {dataToUpdate: {}}
                                        if (!_.isEmpty(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}))) {
                                            data.specificTransactionsDataToUpdate =_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{})
                                            data.transactionsToUpdate = _.map(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}), (value, transactionID) => {
                                                return {_id: transactionID}
                                            })
                                        }
                                        if (_.get(this.state.currentRecord, 'VehoOrderID')) {

                                            if (this.state.currentRecord.changeToGBG || this.state.currentRecord.cancelVehoOrder) {
                                                data.dataToUpdate.VehoOrderID = 'unset';
                                                if (self.state.currentRecord.changeToGBG) {
                                                    self.setState({pending: true});
                                                    self.getVehoOrder().then((response) => {
                                                        return self.cancelVehoOrder().then(() =>
                                                            self.cancelShopifyOrderFulfillments({VehoOrderData: response.data})
                                                        ).then(() => self.createWorkWaveOrder().then((response) => {
                                                            data.dataToUpdate.WorkWaveEventID = response.data._id

                                                            return self.updateOrderTransactions(data).then(function () {
                                                                self.search()
                                                                self.setState({pending: false});
                                                                self.closeModal()
                                                            })
                                                        }))
                                                    }).catch(err => {
                                                        console.log('in err', err);
                                                        self.setState({pending: false});
                                                    })

                                                } else if (self.state.currentRecord.cancelVehoOrder) {
                                                    self.setState({pending: true});
                                                    self.getVehoOrder().then((response) => {
                                                        return self.cancelVehoOrder().then(() => self.updateOrderTransactions(data)).then(() =>
                                                            self.cancelShopifyOrderFulfillments({VehoOrderData: response.data})
                                                        ).then(() => {
                                                            self.search()
                                                            self.setState({pending: false});
                                                            self.closeModal()
                                                        })
                                                    }).catch(err => {
                                                        console.log('in catch ', err);
                                                        self.setState({pending: false});
                                                    })
                                                }
                                            } else { /* update only ProductStatus */
                                                console.log('update only product status'   );
                                                self.updateOrderTransactions(data).then(function () {
                                                    self.search()
                                                    self.setState({pending: false});
                                                    self.closeModal()
                                                }).catch(err => {
                                                    self.setState({pending: false});
                                                })
                                            }
                                        } else if (_.get(this.state.currentRecord, 'WorkWaveEventID')) {

                                            if (self.state.currentRecord.changeToVeho) {
                                                self.setState({pending: true});
                                                data.dataToUpdate.OrderDeliveryDate = 'unset';
                                                data.dataToUpdate.WorkWaveEventID = 'unset';
                                                self.removeWorkWaveOrder(data.dataToUpdate).then(function (response) {

                                                    return self.updateOrderTransactions(data).then(function (response) {
                                                        self.search()
                                                        self.setState({currentScreen: 'VehoScreen', showModal:true, pending: false});
                                                    //    self.closeModal()
                                                    })
                                                }).catch(err => {
                                                    self.setState({pending: false});
                                                })
                                            } else if (self.state.currentRecord.unsetOrderDeliveryDate) {
                                                data.dataToUpdate.OrderDeliveryDate = 'unset';
                                                self.setState({pending: true});
                                                self.updateOrderTransactions(data).then(function () {
                                                    self.search()
                                                    self.setState({pending: false});
                                                    self.closeModal()
                                                }).catch(err => {
                                                    self.setState({pending: false});
                                                })
                                            } else { /* update only ProductStatus */
                                                self.updateOrderTransactions(data).then(function () {
                                                    self.search()
                                                    self.setState({pending: false});
                                                    self.closeModal()
                                                }).catch(err => {
                                                    self.setState({pending: false});
                                                })
                                            }
                                        }

                                    }

                                }}> Update
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen == 'EditShippingScreen') {
             return <div>

                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button className=" right0 pull-left btn btn-primary "
                                disabled={
                                  //  currentProductState == initialProductStateValue
                                    _.isEmpty(_.get(this.state.currentRecord,'specificOrderTransactionsDataToUpdate',{})) &&  !this.state.currentRecord.changeToGBG
                                }
                                type="button"
                                onClick={ () => {
                                    var self = this
                                    if (!this.state.pending) {
                                        var data = {dataToUpdate: {}}
                                        // if (currentProductState !== initialProductStateValue) {
                                        //     dataToUpdate.ProductState = this.state.currentRecord.ProductState
                                        // }
                                        if (!_.isEmpty(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}))) {
                                            data.specificTransactionsDataToUpdate =_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{})
                                            data.transactionsToUpdate = _.map(_.get(self.state.currentRecord,'specificOrderTransactionsDataToUpdate',{}), (value, transactionID) => {
                                                return {_id: transactionID}
                                            })
                                        }
                                        return self.updateOrderTransactions(data).then(function () {
                                            self.search()
                                            self.setState({pending: false});
                                            self.closeModal()
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })


                                    }

                                }}> Update
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen === 'SetDeliveryDateScreen') {
            return <div>
                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Address: </span>
                        <span
                            className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                    </Col>
                    {_.get(this.filteredServiceAreasForLocation, '0') &&
                    <div>


                        {  _.map(this.filteredServiceAreasForLocation, (serviceArea, key) => {
                            return <div key={key}><Col className="top15" xs={12} md={12} sm={12} lg={12}>
                                    <span className="text-bold  right5 purple">
 Service Area: </span>
                                <span
                                    className={classNames('font-size-18', {'green': key % 2 == 0}, {'orange': key % 2 !== 0})}
                                > {_.get(serviceArea, 'Name')} </span>
                            </Col>
                                <Col className="top15" xs={12} md={12} sm={12} lg={12}>
                                                                    <span className="text-bold  right5 purple">
                                      Days of week: </span>
                                    <span
                                        className={classNames('font-size-18', {'green': key % 2 == 0}, {'orange': key % 2 !== 0})}> {_.map(serviceArea.DaysOfWeek, function (dayOfWeek) {
                                        return _.get(_.find(config.services.daysOfWeekMap, {value: dayOfWeek}), 'label', 'n/a')

                                    }).join(', ')} </span>
                                </Col>
                                <Col className="top15" xs={12} md={12} sm={12} lg={12}>
                                                                      <span className="text-bold  right5 purple">
                                                                           Service times: </span>
                                    <span
                                        className={classNames('font-size-18', {'green': key % 2 == 0}, {'orange': key % 2 !== 0})}> {_.map(serviceArea.ServiceTimes, function (serviceTime) {
                                        return _.get(_.find(config.services.timeWindowOptions, {value: serviceTime.value}), 'label', 'n/a')
                                    }).join(', ')} </span>
                                </Col></div>
                        })}


                    </div>
                    }
                </Row>
                {_.get(this.state, 'currentRecord.selectedLocation.key') &&
                <Row>
                    <Col
                         style={{overflow: 'hidden'}}
                        className=" mg-auto top20" xs={12}>
                        <GoogleMapWithServiceAreas
                            ref="googleMapComponent"
                            selectedLocation={this.state.currentRecord.selectedLocation}
                            CurrentLocation={_.get(this.state, 'currentRecord.OrdersData.0.shippingAddressMarketName')  }
                            // displaySearchInput={true}
                            center={this.state.currentRecord.center}
                            updateLocationData={this.updateLocationData.bind(this)}
                            //  mapAddressSelectionCallback={this.mapAddressSelectionCallback.bind(this)}
                            {...this.props} />
                    </Col>
                </Row>
                }
                <Row>
                    <Col xs={12} md={6} className="top30">
                        <FormGroup>
                            <Datetime
                                closeOnSelect={true}
                                dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                onChange={(option) => {
                                    var isSameDate =  moment(this.state.currentRecord['orderDeliveryDate']).isSame(option, 'day')
                                    this.setState({
                                        'currentRecord': {
                                            ...this.state.currentRecord,
                                            orderDeliveryDate: option
                                        }
                                    });
                                }}
                                inputProps={{
                                    placeholder: 'Delivery Date',
                                }}
                                value={   this.state.currentRecord.orderDeliveryDate    }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row className="left0 top30">
                    <Col md={12} sm={12} xs={12} className="pleft0 top10 bot10">
                        <Button style={{width: '300px'}} className="btn btn-lg btn-primary"
                                disabled={this.state.pending || !_.get(this.state.currentRecord, 'orderDeliveryDate')}
                                onClick={(e) => {
                                    var self = this;
                                    if (!this.state.pending) {
                                        return self.updateOrderTransactions({
                                            dataToUpdate: {
                                                'OrderDeliveryDate': _.get(this.state.currentRecord, 'orderDeliveryDate')
                                            }
                                        }).then(function (response) {
                                            return self.sentOrderDeliveryConfirmation({}).then(function (response) {
                                                self.search()
                                                self.setState({pending: false});
                                                self.closeModal()
                                            })
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })
                                    }
                                }}>
                            Set Delivery Date
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top30 pleft0 bot20">
                        <Col md={12} sm={12} xs={12} className="top10 pleft0">
                            <Button className="pull-left btn btn-default" type="button"
                                    onClick={(e) => this.closeModal()}>
                                Cancel
                            </Button>
                        </Col>
                    </Col>
                </Row>
            </div>

        } else if (this.state.currentScreen == 'AddOrderScreen') {
            return <div>
                <Row className='top30'>
                    <Col xs={12} md={6} style={{maxWidth: 300}}>
                        {/*<ControlLabel className="purple">{'Add A ' +(this.state.currentTab == 'Shipping' ? 'Shipping':'Delivery') + ' Order'}</ControlLabel>*/}
                        <Select
                            tabIndex="0"
                            placeholder="Order Type"
                            clearable={false}
                            options={config.orderShippingTypeOptions }
                            onChange={(option) => this.setState({
                                selectedOrderType: option.value
                            })}
                            value={this.state.selectedOrderType}
                        />
                    </Col>
                    {this.state.selectedOrderType == 'Pickup' &&
                    <Col xs={12} md={6} style={{maxWidth: 300}}>
                        <Select
                            tabIndex="0"
                            clearable={false}
                            placeholder="Pickup Location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={ (option) => {
                                this.setState({
                                    'selectedMarket': option ? option.value : null
                                });
                            }}
                            value={this.state.selectedMarket}
                        />
                    </Col>
                    }
                </Row>
                <Row>
                    <Col xs={12} md={6} style={{maxWidth: 300}} className="top20">
                        <FormControl type="text"
                                     defaultValue={this.state.currentRecord.searchText}
                                     onChange={(event) => {
                                         this.setState({
                                             'currentRecord': {
                                                 ...this.state.currentRecord,
                                                 searchText: event.target.value
                                             }
                                         })
                                     }
                                     }
                                     placeholder="Search Order Number"/>
                    </Col>
                </Row>
                <Row className="left0 top20">
                    <Col md={12} sm={12} xs={12} className="pleft0 bot10">
                        <Button className=" right0 pull-left btn btn-primary "
                                type="button"
                                disabled={!(this.state.currentRecord.searchText && this.state.selectedOrderType && (this.state.selectedOrderType !== 'Pickup' || this.state.selectedMarket) )}
                                onClick={ () => {
                                    var self = this
                                    if (!this.state.pending) {
                                        this.searchShopifyOrder().then(function (ShopifyOrder) {
                                            if (self.state.selectedOrderType == 'Pickup' && !_.get(ShopifyOrder, 'customer.id')) {
                                                console.log('not found');
                                                return self.props.displayMessage({
                                                    'messageType': 'warning',
                                                    'messageCode': 'This Shopify order is not linked to a customer and pickup order can not be added'
                                                });
                                            }
                                            console.log('ShopifyOrder', ShopifyOrder);
                                            self.prepareMultipleOrdersScreen({
                                                'SaleData': {
                                                    OrderNumber: self.state.currentRecord.searchText,
                                                    OrderID: ShopifyOrder.id
                                                }
                                            }, 'AddOrderDetailScreen',)

                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })
                                    }
                                }}> Continue
                        </Button>
                    </Col>
                    <Col md={12} sm={12} xs={12} className="top10 pleft0">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (_.includes(['UpdateConnectedTransactionsScreen',], this.state.currentScreen)) {
            return <div>

                <Row>
                    <Col xs={12} className="top20">
                        {_.map(_.get(this.state.currentRecord, 'OrdersData', []), (orderData, index) => {

                            // / var foundPackageData = _.find(this.state.currentRecord.VehoOrderPackageData, packageData => {
                            //     return item.externalId == packageData.externalId
                            // })

                            return <div key={orderData.orderID} className="top30 bot30">
                                <Row>

                                    <Col xs={3} sm={3} md={3} lg={3} className="top10">
                                         <span><span
                                             className="text-bold purple">Order#</span><span>{ ' ' + _.get(orderData, 'OrderTransactions.0.SaleData.OrderNumber', '') }</span></span>


                                    </Col>


                                    <Col xs={5} sm={5} md={5} lg={5} className="pull-right   top10">
                    <span className="pull-right"><span
                        className=" purple text-bold"> Order Date </span><span > {moment(_.get(orderData, 'OrderTransactions.0.createdAt')).format('MM/DD')}</span></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="font-size-19" style={{}} xs={12}>
                                        {this.displayOrderProducts(orderData)}

                                    </Col>
                                </Row>
                            </div>

                        })}
                    </Col>
                </Row>
                <Row className="left0 top20">

                    <Col xs={12} className="top11 bot20 ">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>


                        <Button className=" right0 pull-right btn btn-primary "
                                type="button"
                                disabled={(_.get(self.state, 'currentRecord.connectedOrdersAction') == 'combine' && _.size(_.get(this.state.currentRecord, 'selectedTransactions', [])) < 2) || this.state.pending}
                                onClick={ () => {
                                    var self = this
                                    if (_.get(self.state, 'currentRecord.connectedOrdersAction') == 'combine') {
                                        var ConnectedTransactions = [], selectedOrders = [{OrderTransactions: []}],
                                            TransactionsConnectionID = uuidv4()
                                        var transactionsToConnect = []

                                        _.forEach(self.state.currentRecord.selectedTransactions, selectedTransaction => {
                                            console.log('selectedTransaction', selectedTransaction  );
                                            if (_.size(_.get(selectedTransaction,'AllProductTransactions',[]))){
                                                _.forEach(_.get(selectedTransaction,'AllProductTransactions',[]), transaction => {
                                                    const {ProductItemSKU=''} = (transaction.SaleData || {}).LinkedProductItem || {}
                                                    transactionsToConnect.push({
                                                        OrderID: _.get(transaction, 'SaleData.OrderID'),
                                                        OrderNumber: _.get(transaction, 'SaleData.OrderNumber'),
                                                        LinkedProductItemSKU:ProductItemSKU,
                                                        TransactionID: _.get(transaction, '_id'),
                                                        ProductID: _.get(transaction, 'ProductID._id'),
                                                        TransactionMarketName:_.get(selectedTransaction, 'TransactionMarketName'),
                                                    })
                                                })
                                            }else {
                                                const {ProductItemSKU=''} = (selectedTransaction.SaleData || {}).LinkedProductItem || {}

                                                transactionsToConnect.push({...selectedTransaction,   LinkedProductItemSKU:ProductItemSKU})
                                            }
                                        })

                                         _.forEach(transactionsToConnect, transactionToConnect => {
                                            var index = _.findIndex(ConnectedTransactions, {ShopifyOrderID: transactionToConnect.OrderID})
                                             selectedOrders[0].OrderTransactions.push({
                                                _id: transactionToConnect.TransactionID
                                            })
                                            if (index == -1) {
                                                 ConnectedTransactions.push({

                                                    ShopifyOrderID: transactionToConnect.OrderID,
                                                    ShopifyOrderNumber: transactionToConnect.OrderNumber,
                                                    Transactions: [{
                                                        _id:transactionToConnect.TransactionID,
                                                        LinkedProductItemSKU:transactionToConnect.LinkedProductItemSKU,
                                                        ProductID:transactionToConnect.ProductID,
                                                        MarketName:transactionToConnect.TransactionMarketName}]
                                                })
                                            } else {
                                                ConnectedTransactions[index].Transactions.push({
                                                    _id:transactionToConnect.TransactionID,
                                                    LinkedProductItemSKU:transactionToConnect.LinkedProductItemSKU,
                                                    ProductID:transactionToConnect.ProductID,
                                                    MarketName:transactionToConnect.TransactionMarketName})
                                            }
                                        })
                                        ConnectedTransactions = _.orderBy(ConnectedTransactions, item => {
                                            return item.ShopifyOrderNumber
                                        }, 'asc')

                                        var dataToUpdate = {
                                            TransactionsConnectionID: TransactionsConnectionID,
                                            ConnectedTransactions: ConnectedTransactions
                                        }
                                      // return/*revert*/
                                        if (!this.state.pending) {
                                            var promise = this.combineTransactions(selectedOrders, dataToUpdate)
                                        }
                                    } else {
                                        selectedOrders = this.state.currentRecord.OrdersData

                                        var promise = this.props.makeRequest({
                                            TransactionsConnectionID: _.get(this.state.currentRecord, 'ConnectedTransactionsData.TransactionsConnectionID')
                                        }, {
                                            "type": 'post',
                                            "endpoint": '/transactions/uncombine_transactions',
                                        })
                                    }
                                    if (!this.state.pending) {
                                        promise.then(function () {

                                            self.setState({showModal: false, pending: false});
                                            self.search()
                                        }).catch(err => {
                                            console.log('uncombine err', err);
                                            self.setState({pending: false});
                                        })
                                    }

                                }}> {_.get(self.state, 'currentRecord.connectedOrdersAction') == 'combine' ? 'Combine Orders' : 'Un-combine orders'}
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (_.includes(['RemoveClaimsForTransactions',], this.state.currentScreen)) {
            return <div>

                <Row>
                    <Col xs={12} className="top20">
                        {_.map(_.get(this.state.currentRecord, 'OrdersData', []), (orderData, index) => {

                            return <div key={orderData.orderID} className="top30 bot30">
                                <Row>

                                    <Col xs={3} sm={3} md={3} lg={3} className="top10">
                                         <span><span
                                             className="text-bold purple">Order#</span><span>{ ' ' + _.get(orderData, 'OrderTransactions.0.SaleData.OrderNumber', '') }</span></span>


                                    </Col>


                                    <Col xs={5} sm={5} md={5} lg={5} className="pull-right   top10">
                    <span className="pull-right"><span
                        className=" purple text-bold"> Order Date </span><span > {moment(_.get(orderData, 'OrderTransactions.0.createdAt')).format('MM/DD')}</span></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="font-size-19" style={{}} xs={12}>
                                        {this.displayOrderProducts(orderData)}

                                    </Col>
                                </Row>
                            </div>

                        })}
                    </Col>
                </Row>
                <Row className="left0 top20">

                    <Col xs={12} className="top11 bot20 ">
                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>


                        <Button className=" right0 pull-right btn btn-primary "
                                type="button"
                                disabled={ _.size(_.get(this.state.currentRecord, 'selectedTransactions', [])) == 0 || this.state.pending}
                                onClick={ () => {
                                    var self = this
                                    var transactionsToUpdate = []

                                     _.forEach(self.state.currentRecord.selectedTransactions, item => {
                                        if (_.size(_.get(item,'AllProductTransactions',[]))){
                                            _.forEach(_.get(item,'AllProductTransactions',[]), transaction => {
                                                transactionsToUpdate.push(transaction)
                                            })
                                        }else {
                                            transactionsToUpdate.push({_id:_.get(item, 'TransactionID', {})})
                                        }
                                    })
                                    console.log('transactionsToUpdate', transactionsToUpdate  );
                                    if (!this.state.pending) {
                                        return self.updateOrderTransactions({
                                            dataToUpdate: {
                                                ClaimedByUserID: 'unset'
                                            },
                                            transactionsToUpdate: transactionsToUpdate,
                                        }).then(function () {
                                            self.setState({showModal: false, pending: false});
                                            self.search()
                                        }).catch(err => {

                                            self.setState({pending: false});
                                        })
                                    }
                                }}>Remove Claims
                        </Button>
                    </Col>
                </Row>
            </div>
        } else if (this.state.currentScreen === 'AddOrderDetailScreen') {
            return <div>

                <Row className='top30'>
                    <Col xs={12} md={12} sm={12} lg={12}>
                        <span className="text-bold  purple right5">Address: </span>
                        <span
                            className="font-size-18"> {_.get(this.state.currentRecord, 'OrdersData.0.shippingAddressString', 'n/a')} </span>
                    </Col>
                </Row>

                <Row className="left0 top30">
                    <Col md={12} sm={12} xs={12} className="pleft0 top10 bot10">
                        <Button style={{width: '400px'}} className="btn btn-lg btn-primary"
                                disabled={!(!this.state.pending && _.size(_.get(this.state.currentRecord, 'selectedProducts', [])) && _.get(this.searchBox, 'state.filterOptions.Market') )  }
                                onClick={() => {
                                    var self = this;
                                    var searchWarehousePickupOrderPromise = Promise.resolve(undefined)
                                    console.log('searchWarehousePickupOrderPromise 1', searchWarehousePickupOrderPromise);
                                    if (self.state.selectedOrderType == 'Pickup') {
                                        searchWarehousePickupOrderPromise = self.searchWarehousePickupOrder()
                                    } else {
                                        var PickupTransactionFound = _.find(self.state.currentRecord.selectedProducts, item => {
                                            return _.get(item, 'Transaction.SaleData.OrderShippingType') == 'Pickup'
                                        })
                                        console.log('PickupTransactionFound', PickupTransactionFound);
                                        if (PickupTransactionFound) {
                                            searchWarehousePickupOrderPromise = self.searchWarehousePickupOrder()
                                        }
                                    }
                                     searchWarehousePickupOrderPromise.then(function (warehousePickupOrder) {
                                        var addOrUpdateWarehousePickupOrderPromise
                                        var transactionsToUpdate = []
                                        _.forEach(self.state.currentRecord.selectedProducts, item => {
                                            if (_.size(_.get(item,'AllProductTransactions',[]))){
                                                _.forEach(_.get(item,'AllProductTransactions',[]), transaction => {
                                                         transactionsToUpdate.push(transaction)
                                                })
                                            }else {
                                                transactionsToUpdate.push(_.get(item, 'Transaction', {}))
                                            }
                                        })
                                         if (self.state.selectedOrderType == 'Pickup') {
                                            console.log('warehousePickupOrder 1', warehousePickupOrder);
                                            var dataToSave = {
                                                ProductsToAdd: _.map(transactionsToUpdate, item => {
                                                    return {
                                                        ProductName: _.get(item, 'ProductID.ProductName'),
                                                        Amount: _.get(item, 'SaleData.ProductPrice'),
                                                        ProductID: _.get(item, 'ProductID._id'),
                                                        TransactionID: _.get(item, '_id'),
                                                    }
                                                })
                                            }
                                            if (warehousePickupOrder) {
                                                addOrUpdateWarehousePickupOrderPromise = self.updateWarehousePickupOrder(warehousePickupOrder, dataToSave)
                                            } else {
                                                addOrUpdateWarehousePickupOrderPromise = self.addWarehousePickupOrder(dataToSave)
                                            }
                                        } else {
                                            console.log('warehousePickupOrder 2', warehousePickupOrder);
                                            if (warehousePickupOrder) {/* if warehouse pickup order found, delete product transactions from it*/
                                                var selectedProductIDs = _.map(transactionsToUpdate, item => {
                                                    return _.get(item, 'ProductID._id')
                                                })
                                                var productReferenceToDelete = _.filter(_.get(warehousePickupOrder, 'Products', []), productData => {
                                                    return _.includes(selectedProductIDs, productData.ProductID)
                                                })
                                                var dataToUpdate = {
                                                    ProductsToDelete: productReferenceToDelete
                                                }
                                                if (_.get(warehousePickupOrder, 'Products', []).length == productReferenceToDelete.length) {  /* set warehouse pickup order as Deleted, if all references must be removed */
                                                    dataToUpdate.Deleted = true
                                                }
                                                addOrUpdateWarehousePickupOrderPromise = self.updateWarehousePickupOrder(warehousePickupOrder, dataToUpdate)
                                            } else {
                                                addOrUpdateWarehousePickupOrderPromise = Promise.resolve(undefined)
                                            }
                                        }
                                        console.log('transactionsToUpdate', transactionsToUpdate  );

                                        return addOrUpdateWarehousePickupOrderPromise.then(function (response) {
                                            return self.updateOrderTransactions({
                                                dataToUpdate: {
                                                    OrderShippingType: self.state.selectedOrderType,
                                                }, transactionsToUpdate: transactionsToUpdate /*covered*/
                                            }).then(function (response) {
                                                self.search()
                                                self.setState({pending: false});
                                                self.closeModal()
                                            })
                                        })

                                    }).catch(err => {
                                        self.setState({pending: false});
                                    })
                                }}>
                            Add To { this.state.selectedOrderType} Queue
                        </Button>
                    </Col>
                </Row>
                <Row className="left0 top10">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button style={{width: '80px'}} className=" right0 pull-left btn btn-default"
                                type="button"
                                onClick={(e) => this.setState({
                                    currentScreen: 'AddOrderScreen',
                                })}>
                            Back
                        </Button>
                        <Button style={{width: '80px'}} className="pull-right btn right20 btn-default" type="button"
                                onClick={(e) => {
                                    this.setState({
                                        currentScreen: 'AddOrderScreen',
                                    })
                                    this.closeModal()
                                }}>

                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>

        } else if (this.state.currentScreen == 'CreateOrderConfirmationScreen') {
            return <div>
                {_.map(_.get(this.state.currentRecord, 'VehoOrderData.packages', []), (item, index) => {
                    var foundPackageData = _.find(this.state.currentRecord.VehoOrderPackageData, packageData => {
                        return item.externalId == packageData.externalId
                    })
                    if (foundPackageData) {
                        return <Row key={index} className="top30 bot30">
                            <Col className="font-size-19" style={{}} xs={12}>
                                {'Package   ' + foundPackageData.packageDimensions}
                                <a target="_blank" className="pleft20"
                                   href={ _.get(item, 'pdfShippingLabelLink')}>{'PDF link'} </a>
                            </Col>

                        </Row>
                    } else {
                        return null
                    }
                })}

                <Row className="left0 top10">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button style={{width: '80px'}} className=" right0 pull-left btn btn-primary"
                                type="button"
                                onClick={(e) => {
                                    this.search()
                                    this.setState({pending: false});
                                    this.closeModal()
                                }}>
                            Close
                        </Button>

                    </Col>
                </Row>

            </div>
        }else if (this.state.currentScreen == 'PrintFedExLabelScreen') {
            return <div>
                {_.map(_.get(this.state.currentRecord, 'FedexShippingData.FedExShipmentPackagesData', []), (item, index) => {
                        return <Row key={index} className="top30 bot30">
                            <Col className="font-size-19" style={{}} xs={12}>
                                <div className="pull-left" style={{width:220}}> {'Package   ' + _.get(item,'PackageLength','n/a') +' x '+_.get(item,'PackageWidth','n/a') +' x '+ _.get(item,'PackageHeight','n/a') }</div>
                                <a target="_blank" className="pull-left pleft20"
                                   href={ _.get(item, 'LabelPDFLink')}>{'PDF link'} </a>
                            </Col>
                        </Row>
                })}
                <Row className="left0 top10">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button style={{width: '80px'}} className=" right0 pull-left btn btn-primary"
                                type="button"
                                onClick={(e) => {
                                    this.search()
                                    this.setState({pending: false});
                                    this.closeModal()
                                }}>
                            Close
                        </Button>
                        {config.getEnvironmentName() !== 'local' &&
                        <Button className="left20  right0 pull-left btn btn-primary"
                                type="button"
                                onClick={(e) => {
                                    this.cancelFedexShipment()
                                    this.setState({pending: false});
                                    this.closeModal()
                                }}>
                            Cancel Label
                        </Button>
                        }
                    </Col>
                </Row>

            </div>
        }else if (this.state.currentScreen == 'FulfillFedExOrderScreen') {
            return <div>


                <Row className="left0 top10">
                    <Col md={12} sm={12} xs={12} className="pleft0">
                        <Button style={{width: '120px'}}
                                disabled={this.state.pending}
                                className=" right0 pull-right btn btn-primary"
                                type="button"
                                onClick={(e) => {
                                    if (this.state.pending){
                                        return
                                    }
                                     this.fulfillOrdersWithFedExData()
                                }}>
                            Fulfill Order
                        </Button>

                    </Col>
                </Row>

            </div>
        }
    }

    updateShopifyOrders() {
        return new Promise((resolve, reject) => {
            var self = this, functionsToCall = [], ordersToUpdate = []
            console.log(' ordersToUpdate', ordersToUpdate);
            if (_.size(_.get(self.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), (orderData) => {
                    _.forEach(_.get(orderData, 'OrderTransactions', []), (transaction) => {
                        if (_.size(_.get(orderData, 'ConnectedOrderTransactions', [])) && _.includes(orderData.ConnectedOrderTransactions, transaction._id)) {
                            ordersToUpdate.push(_.get(transaction, 'SaleData.OrderID'))
                        }
                    })
                })
            } else {
                ordersToUpdate = [_.get(this.state.currentRecord, 'SaleData.OrderID')]
            }
            console.log(' ordersToUpdate', ordersToUpdate);
            self.setState({pending: true});
            var shippingAddress = _.get(self.state.currentRecord, 'OrdersData.0.orderShippingAddress', {})
            if (!_.isEmpty(_.get(self.state.currentRecord, 'shippingAddressToSave', {})) && (
                _.get(self.state.currentRecord, 'shippingAddressToSave.city', '') !== _.get(shippingAddress, 'city') ||
                _.get(self.state.currentRecord, 'shippingAddressToSave.address1', '') !== _.get(shippingAddress, 'address1') ||
                _.get(self.state.currentRecord, 'shippingAddressToSave.address2', '') !== _.get(shippingAddress, 'address2') ||
                _.get(self.state.currentRecord, 'shippingAddressToSave.zip', '') !== _.get(shippingAddress, 'zip') ||
                _.get(self.state.currentRecord, 'shippingAddressToSave.province_code', '') !== _.get(shippingAddress, 'province_code'))

            ) {
                shippingAddress = _.extend(shippingAddress, self.state.currentRecord.shippingAddressToSave)
            }
            _.forEach(ordersToUpdate, function (ShopifyOrderID, index) {
                functionsToCall.push(function (done) {
                    self.props.makeRequest({
                        shippingAddress: shippingAddress,
                        ShopifyOrderID: ShopifyOrderID
                    }, {
                        type: 'patch',
                        "endpoint": "/shopify_orders",
                        messageCode: 'Shipping address updated'
                    }).then(function (response) {

                        done()
                    }).catch(err => {
                        return done(err)
                    });
                })
            })
            async.series(functionsToCall,
                function (err, responses) {
                    self.setState({pending: false});
                    if (err) {
                        return reject(err)
                    }
                    resolve({
                        ShopifyOrderShippingAddress: shippingAddress
                    })
                })
        })
    }

    sentOrderDeliveryConfirmation() {
        var self = this

        var methodData = {
            type: 'post',
            "endpoint": "/process-action",
            messageCode: 'Email sent to customer'
        };
        if (!_.get(self.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.email', '')) {
            return Promise.resolve()
        }
        var shippingAddress = _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress', {})
        var ProductsTitleList = ''
        if (_.size(_.get(this.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
            var OrderNumber = _.map(_.get(this.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []), function (item) {
                return _.get(item, 'ShopifyOrderNumber', '')
            }).join(', ')
            _.forEach(_.get(this.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []), function (item) {
                _.forEach(_.get(item, 'Transactions', []), transactionData => {
                    ProductsTitleList += _.get(transactionData, 'SaleData.ProductName') + ' '
                })
            })


        } else {
            var OrderNumber = _.get(this.state.currentRecord, 'SaleData.OrderNumber', '')
            ProductsTitleList = _.map(_.get(self.state.currentRecord, 'OrderTransactions', []), 'ProductID.ProductName').join(',')
        }
        return this.props.makeRequest({
            action: 'SentEmailByType',
            emailType: 'order_delivery_confirmation',
            to: _.get(self.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.email', ''),
            emailData: {
                OrderNumber: OrderNumber,
                UserFirstName:  self.state.currentRecord.ShopifyCustomerFirstName ? self.state.currentRecord.ShopifyCustomerFirstName : '',
                OrderShippingAddress: _.get(shippingAddress, 'address1', '') + ', ' + ( _.get(shippingAddress, 'address2', '') ? shippingAddress.address2 + ', ' : '') + _.get(shippingAddress, 'city', '') + ' ' + _.get(shippingAddress, 'zip', ''),
                OrderDeliveryDate: moment(_.get(self.state.currentRecord, 'orderDeliveryDate')).format('MM-DD-YYYY')
            }
        }, methodData).then(function (response) {

            return response
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    removeWorkWaveOrder(dataToUpdate) {
        var self = this
        if (!dataToUpdate.WorkWaveEventID) {
            return Promise.resolve(true)
        }
        this.setState({pending: true});
        var methodData = {
            type: 'delete',
            "endpoint": "/workwave_orders",
            messageCode: 'WorkWave order deleted'
        };
        var WorkWaveOrderIDToDelete = _.get(this.state.currentRecord, ['WorkWaveEventID', 'CreatedOrders', '0', 'id'], false) || _.get(this.state.currentRecord, ['WorkWaveRequestID', 'UpdatedOrders', '0', 'id'], false)

        if (config.getEnvironmentName() == 'production' && (_.get(this.state.currentRecord, ['WorkWaveEventID', 'Status'], '') !== 'Completed' || !WorkWaveOrderIDToDelete)) {
            self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Sorry, can not remove order in WorkWave. ' + (WorkWaveOrderIDToDelete ? 'Event status must be Completed' : 'Reference to it is not available')
            });
            return Promise.reject(true)
        }

        const {filterOptions = {}} =  this.searchBox && this.searchBox.state ? this.searchBox.state : {}
       console.log('filterOptions', filterOptions  );
        const {Market = {}} = filterOptions
        return this.props.makeRequest({
            WorkWaveOrderIDToDelete: WorkWaveOrderIDToDelete,
            TerritoryID: _.get(this.state.currentRecord, ['WorkWaveEventID', 'TerritoryID']),
            WorkWaveEventCustomData: {User: self.props.userReducer.user.firstName},
            ShopifyOrderID: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.id', ''),
            MarketName:Market
        }, methodData).then(function (response) {

            return response
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    createWorkWaveOrder() {
        var self = this
        this.setState({pending: true});
        var methodData = {
            type: 'post',
            timeout: 30000,
            "endpoint": "/workwave_orders",
            messageCode: 'WorkWave order created'
        };
        var phoneNumber = ''
        if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.billing_address.phone')) {
            phoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.billing_address.phone')
        } else if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.phone')) {
            phoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.phone')
        } else if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.phone')) {
            phoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.phone')
        } else if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_lines.0.phone')) {
            phoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_lines.0.phone')
        } else if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.phone')) {
            phoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.phone');
        }
        phoneNumber  = unformatPhoneNumber(phoneNumber)
        var shippingAddress = _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress', {})
        const {province_code = ''} = shippingAddress;
        try {
            const foundWarehouseRecord = getWarehouseDataByProvinceCode({warehouseData:config.warehouseData, provinceCode:province_code});

             if(!foundWarehouseRecord) {
                var message = 'Can not create WorkWave order as service is not available for address '+_.get(shippingAddress, 'address1', '') + ', ' + ( _.get(shippingAddress, 'address2', '') ? shippingAddress.address2 + ', ' : '') + _.get(shippingAddress, 'city', '') + ', ' + _.get(shippingAddress, 'province_code', '') + ' ' + _.get(shippingAddress, 'zip', '')
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode':message
                });
              throw ({message:message})
            }
            var timeZoneName = _.get(foundWarehouseRecord, 'timeZoneName')
            console.log('timezonename', timeZoneName, momentTimeZone(_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.created_at')).tz(timeZoneName));
            var workwaveOrderData = {
                WorkWaveEventCustomData: {User: self.props.userReducer.user.firstName},
                ShopifyOrderID: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.id', ''),
                Name: (config.getEnvironmentName() == 'production' ? '' : 'Testing ') + 'Order #' + _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.order_number', ''),
                Address: _.get(shippingAddress, 'address1', '') + ', ' + ( _.get(shippingAddress, 'address2', '') ? shippingAddress.address2 + ', ' : '') + _.get(shippingAddress, 'city', '') + ', ' + _.get(shippingAddress, 'province_code', '') + ' ' + _.get(shippingAddress, 'zip', '') + ', USA',
                OrderDate: moment().add(3, 'days').format('YYYYMMDD'),
                MarketName:foundWarehouseRecord.MarketName,
                CustomFields: {
                    'Order ID': _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.id', ''),
                    "Email": _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.email', ''),
                    "Name": _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.first_name', '') + ' ' + _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.last_name', ''),
                    "Phone": phoneNumber ? '+1'+phoneNumber :''
                },
                Notes: (config.getEnvironmentName() == 'production' ? '' : 'Testing order ') + (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.note') ? _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.note') : '')
            }
        } catch (e) {
            console.log('e', e);
            return Promise.reject(e)
        }
        return this.props.makeRequest(workwaveOrderData, methodData).then(function (response) {

            return response
        }).catch(err => {
            return Promise.reject(err)
        });
    }
    fulfillOrdersWithFedExData() {
        return new Promise((resolve, reject) => {
            this.setState({pending:true})

            var self = this, functionsToCall = []
           // _.forEach(_.get(self.state.currentRecord.FedexShippingData, 'FedExShipmentPackagesData', []), function (FedExShipmentPackage, index) {
                var ShopifyProductIDsForOrder ={}

                var orderIDs = []
                _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), orderData => {
                    ShopifyProductIDsForOrder[orderData.orderID] = []
                    orderIDs.push(orderData.orderID)
                   _.forEach(_.get(orderData, 'OrderProducts', []), orderProduct => {
                       console.log('orderProduct', orderProduct  );
                       if (_.get(this.searchBox, 'state.filterOptions.Market')) {
                           var MarketNameToCheck =  _.get(config.warehouseData[  _.get(orderProduct, 'Transaction.MarketName', '')],'FulfillmentCenter',  _.get(orderProduct, 'Transaction.MarketName', ''))

                         console.log('MarketNameToCheck', MarketNameToCheck ,_.get(this.searchBox, 'state.filterOptions.Market') );
                           if (MarketNameToCheck == _.get(this.searchBox, 'state.filterOptions.Market')) {
                               ShopifyProductIDsForOrder[orderData.orderID].push(orderProduct.product_id.toString())
                            }
                       }

                    //    console.log('orderProduct', orderProduct);
                        //    if (_.includes(ShopifyProductIDs, _.get(orderProduct, 'product_id').toString())) {

                        //  }
                   })
                })


                _.forEach(_.uniq(orderIDs), orderID => {
                    if(_.get(ShopifyProductIDsForOrder,[orderID],[]).length ==0){
                        return true
                    }

                    functionsToCall.push(function (done) {
                        // var foundPackage = _.find(data.VehoOrderPackages,item=>{
                        //     return item.externalId == VehoOrderPackage.externalId
                        // })
                        var Location = _.find(config.getEnvironment().shopify.locationsDataMap, {MarketName: _.get(self.searchBox, 'state.filterOptions.Market')})

                        var fulfillmentData = {
                            order_id: orderID,
                            tracking_company: 'FedEx',
                            location_id: Location.ShopifyLocationID,
                            //  tracking_numbers: [VehoOrderPackage.barCode],
                            //  tracking_urls: ['https://track.shipveho.com/#/barcode/' + VehoOrderPackage.barCode],
                            tracking_number: _.get(self.state.currentRecord,'FedexShippingData.MasterTrackingNumber','n/a'),
                            tracking_url: 'https://www.fedex.com/fedextrack/?tracknumbers='+_.get(self.state.currentRecord,'FedexShippingData.MasterTrackingNumber','n/a')+'&cntry_code=us',
                            ShopifyProductIDs: ShopifyProductIDsForOrder[orderID],
                            action: 'createShopifyOrderFulfillment'
                        }

                        self.props.makeRequest(fulfillmentData, {
                            "type": 'post',
                            "endpoint": "/products/customAction",

                        }).then(response => {
                            //   setTimeout(function() {/* this is required as when two parallel requests  to create fulfillments  are sent, an error is thrown from Shopify for one of them*/
                            done(null)
                            //   },5000)
                        }).catch(error => {
                            console.log('error', error  );
                            done(null) /* do not stop processing other requests. For example, when 'Line items not found' error is returned for the first request.   */
                           // done(error)
                        });

                    })
          //      })
            })
            if (functionsToCall.length==0){
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'No items are found for fulfillment'
                })
            }
            console.log('functionsToCall', functionsToCall);
            async.series(functionsToCall,
                function (err, responses) {
                    if (err) {
                         console.log('err', err  );
                    }
                    self.setState({
                        currentRecord: {
                            ...self.state.currentRecord,
                        },


                    }, () => {
                        setTimeout(()=> {/*wait 10  seconds till transactions are updated with fulfillment webhook*/
                            self.search()
                            self.setState({pending:false})
                            self.closeModal()
                        },10000)
                    })
                })
         })
    }

    fulfillOrdersWithVehoData(data) {
        return new Promise((resolve, reject) => {
            var self = this, functionsToCall = []
            _.forEach(_.get(data.VehoOrderData, 'packages', []), function (VehoOrderPackage, index) {

                var ShopifyProductIDs = _.get(VehoOrderPackage, 'externalId') ? _.get(VehoOrderPackage, 'externalId').split(',') : []
                console.log('ShopifyProductIDs', ShopifyProductIDs);
                var orderIDs = []
                _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), orderData => {
                    _.forEach(_.get(orderData, 'OrderProducts', []), orderProduct => {
                        console.log('orderProduct', orderProduct);
                        if (_.includes(ShopifyProductIDs, _.get(orderProduct, 'product_id').toString())) {
                            orderIDs.push(orderData.orderID)
                        }
                    })
                })
                console.log('orderIDs', orderIDs);
                _.forEach(_.uniq(orderIDs), orderID => {
                    functionsToCall.push(function (done) {
                        // var foundPackage = _.find(data.VehoOrderPackages,item=>{
                        //     return item.externalId == VehoOrderPackage.externalId
                        // })
                        var Location = _.find(config.getEnvironment().shopify.locationsDataMap, {MarketName: _.get(self.searchBox, 'state.filterOptions.Market')})

                        var fulfillmentData = {
                            order_id: orderID,
                            tracking_company: 'Veho',
                            location_id: Location.ShopifyLocationID,
                            //  tracking_numbers: [VehoOrderPackage.barCode],
                            //  tracking_urls: ['https://track.shipveho.com/#/barcode/' + VehoOrderPackage.barCode],
                            tracking_number: VehoOrderPackage.barCode,
                            tracking_url: 'https://track.shipveho.com/#/barcode/' + VehoOrderPackage.barCode,
                            ShopifyProductIDs: ShopifyProductIDs,
                            action: 'createShopifyOrderFulfillment'
                        }

                        self.props.makeRequest(fulfillmentData, {
                            "type": 'post',
                            "endpoint": "/products/customAction",

                        }).then(response => {
                            //   setTimeout(function() {/* this is required as when two parallel requests  to create fulfillments  are sent, an error is thrown from Shopify for one of them*/
                            done(null)
                            //   },5000)
                        }).catch(error => {
                            done(error)
                        });

                    })
                })
            })
            console.log('functionsToCall', functionsToCall);
            async.series(functionsToCall,
                function (err, responses) {
                    if (err) {
                        return reject(err)
                    }
                    resolve()
                })
        })
    }
    cancelFedExShipment() {
        return new Promise((resolve, reject) => {
            this.setState({pending:true})

            var self = this, functionsToCall = []
            // _.forEach(_.get(self.state.currentRecord.FedexShippingData, 'FedExShipmentPackagesData', []), function (FedExShipmentPackage, index) {
            var ShopifyProductIDsForOrder ={}

            var orderIDs = []
            _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), orderData => {
                ShopifyProductIDsForOrder[orderData.orderID] = []
                orderIDs.push(orderData.orderID)
                _.forEach(_.get(orderData, 'OrderProducts', []), orderProduct => {
                    console.log('orderProduct', orderProduct  );
                    if (_.get(this.searchBox, 'state.filterOptions.Market')) {
                        var MarketNameToCheck =  _.get(config.warehouseData[  _.get(orderProduct, 'Transaction.MarketName', '')],'FulfillmentCenter',  _.get(orderProduct, 'Transaction.MarketName', ''))

                        console.log('MarketNameToCheck', MarketNameToCheck ,_.get(this.searchBox, 'state.filterOptions.Market') );
                        if (MarketNameToCheck == _.get(this.searchBox, 'state.filterOptions.Market')) {
                            ShopifyProductIDsForOrder[orderData.orderID].push(orderProduct.product_id.toString())
                        }
                    }

                    //    console.log('orderProduct', orderProduct);
                    //    if (_.includes(ShopifyProductIDs, _.get(orderProduct, 'product_id').toString())) {

                    //  }
                })
            })


            _.forEach(_.uniq(orderIDs), orderID => {
                if(_.get(ShopifyProductIDsForOrder,[orderID],[]).length ==0){
                    return true
                }

                functionsToCall.push(function (done) {
                    // var foundPackage = _.find(data.VehoOrderPackages,item=>{
                    //     return item.externalId == VehoOrderPackage.externalId
                    // })
                    var Location = _.find(config.getEnvironment().shopify.locationsDataMap, {MarketName: _.get(self.searchBox, 'state.filterOptions.Market')})

                    var fulfillmentData = {
                        order_id: orderID,
                        tracking_company: 'FedEx',
                        location_id: Location.ShopifyLocationID,
                        //  tracking_numbers: [VehoOrderPackage.barCode],
                        //  tracking_urls: ['https://track.shipveho.com/#/barcode/' + VehoOrderPackage.barCode],
                        tracking_number: _.get(self.state.currentRecord,'FedexShippingData.MasterTrackingNumber','n/a'),
                        tracking_url: 'https://www.fedex.com/fedextrack/?tracknumbers='+_.get(self.state.currentRecord,'FedexShippingData.MasterTrackingNumber','n/a')+'&cntry_code=us',
                        ShopifyProductIDs: ShopifyProductIDsForOrder[orderID],
                        action: 'createShopifyOrderFulfillment'
                    }

                    self.props.makeRequest(fulfillmentData, {
                        "type": 'post',
                        "endpoint": "/products/customAction",

                    }).then(response => {
                        //   setTimeout(function() {/* this is required as when two parallel requests  to create fulfillments  are sent, an error is thrown from Shopify for one of them*/
                        done(null)
                        //   },5000)
                    }).catch(error => {
                        console.log('error', error  );
                        done(null) /* do not stop processing other requests. For example, when 'Line items not found' error is returned for the first request.   */
                        // done(error)
                    });

                })
                //      })
            })
            if (functionsToCall.length==0){
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'No items are found for fulfillment'
                })
            }
            console.log('functionsToCall', functionsToCall);
            async.series(functionsToCall,
                function (err, responses) {
                    if (err) {
                        console.log('err', err  );
                    }
                    self.setState({
                        currentRecord: {
                            ...self.state.currentRecord,
                        },


                    }, () => {
                        setTimeout(()=> {/*wait 5  seconds till transactions are updated with fulfillment webhook*/
                            self.search()
                            self.setState({pending:false})
                            self.closeModal()
                        },10000)
                    })
                })
        })
    }
    cancelShopifyOrderFulfillments(data) {
        return new Promise((resolve, reject) => {
            var self = this, functionsToCall = []
            _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), orderData => {
                _.forEach(_.get(data.VehoOrderData, 'packages', []), function (VehoOrderPackage, index) {

                    var foundFulfillment = _.find(_.get(orderData, 'ShopifyOrder.fulfillments', []), item => {
                        return item.tracking_company == "Veho" && item.tracking_number == VehoOrderPackage.barCode
                    })
                    console.log('foundFulfillment', foundFulfillment);
                    if (foundFulfillment) {
                        var params = {
                            orderID: _.get(orderData, 'orderID', ''),
                            action: 'cancelShopifyOrderFulfillment',
                            fulfillmentID: foundFulfillment.id,
                        }
                        functionsToCall.push(function (done) {
                            self.props.makeRequest(params, {
                                "type": 'post',
                                "endpoint": "/products/customAction",
                            }).then(response => {
                                //   setTimeout(function() {/* this is required as when two parallel requests  to create fulfillments  are sent, an error is thrown from Shopify for one of them*/
                                done(null)
                                //   },5000)
                            }).catch(error => {
                                done(error)
                            });
                        })
                    }
                })
            })
            async.series(functionsToCall,
                function (err, responses) {
                    if (err) {
                        return reject(err)
                    }
                    resolve()
                })
        })
    }

    updateOrderTransactions(params) {
        return new Promise((resolve, reject) => {
console.log('updateOrderTransactions', params  );
            var self = this, functionsToCall = []
            if (!params.transactionsToUpdate) {
                params.transactionsToUpdate = []
                if (_.size(_.get(self.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                    _.forEach(_.get(self.state.currentRecord, 'OrdersData', []), (orderData) => {
                        _.forEach(_.get(orderData, 'OrderTransactions', []), (transaction) => {
                            if (_.size(_.get(orderData, 'ConnectedOrderTransactions', [])) && _.includes(orderData.ConnectedOrderTransactions, transaction._id)) {
                                params.transactionsToUpdate.push(transaction)
                            }
                        })
                    })
                } else {
                    params.transactionsToUpdate = _.get(this.state.currentRecord, 'OrdersData.0.OrderTransactions', [])
                }
            }
            console.log('updateOrderTransactions', params.transactionsToUpdate);
            _.forEach(params.transactionsToUpdate, function (transaction, index) {
                functionsToCall.push(function (done) {
                    var dataToUpdate = _.cloneDeep(params.dataToUpdate)
                    if (!_.isEmpty(_.get(params, ['specificTransactionsDataToUpdate', transaction._id], {}))) {
                        var dataToUpdate = _.extend({}, params.dataToUpdate, _.get(params, ['specificTransactionsDataToUpdate', transaction._id], {}))
                    }
                    console.log('dataToUpdate 1', dataToUpdate    );
                    if (!_.size(_.get(self.state.currentRecord, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                        if (dataToUpdate.ProductState && transaction.MarketName) {/* update ProductState only for transactions linked to the selected Market*/
                            /* MarketName is not available when specificOrderTransactionsDataToUpdate are used*/
                            var MarketNameToCheck =_.get(config.warehouseData[ transaction.MarketName],'FulfillmentCenter', transaction.MarketName)

                            console.log('MarketNameToCheck', MarketNameToCheck ,_.get(self, 'searchBox.state.filterOptions.Market', 'n/a') );
                            if (MarketNameToCheck !== _.get(self, 'searchBox.state.filterOptions.Market', 'n/a')) {
                                delete dataToUpdate.ProductState
                            }
                        }
                    }
                    console.log('dataToUpdate', dataToUpdate  );
                    if (_.isEmpty(dataToUpdate)) {
                        return done(null)
                    }
                    self.props.makeRequest(dataToUpdate, {
                        "endpoint": "/transactions/" + encodeURIComponent(transaction._id),
                        "type": 'patch',

                    }).then(response => {
                        done(null)
                    }).catch(error => {
                        console.log('error', error);
                        done(error)
                    });
                })
            })
            console.log('functionsToCall', functionsToCall);
            async.parallel(functionsToCall,
                function (err, responses) {
                    if (err) {
                        return reject(err)
                    }
                    resolve()

                })
        })
    }

    combineTransactions(selectedOrders, dataToUpdate) {
        return new Promise((resolve, reject) => {


            var self = this, functionsToCall = []
            _.forEach(selectedOrders, function (selectedOrder, index) {
                console.log('selectedOrder', selectedOrder);
                _.forEach(selectedOrder.OrderTransactions, function (orderTransaction, index) {
                    functionsToCall.push(function (done) {
                        console.log('orderTransaction', orderTransaction);
                        // var dataToSave = {}
                        // if (dataToUpdate.ConnectedTransactions !== 'unset') {
                        //     dataToSave.ConnectedTransactions = _.reject(dataToUpdate.ConnectedTransactions, item => {
                        //         console.log('orderid', _.get(orderTransaction, 'SaleData.OrderID'), item.ShopifyOrderID);
                        //         return item.ShopifyOrderID == _.get(orderTransaction, 'SaleData.OrderID')
                        //     })
                        // } else {
                        //     dataToSave = dataToUpdate
                        // }
                        self.props.makeRequest(dataToUpdate, {
                            "type": 'patch',
                            "endpoint": "/transactions/" + encodeURIComponent(orderTransaction._id),

                        }).then(response => {
                            //   setTimeout(function() {/* this is required as when two parallel requests  to create fulfillments  are sent, an error is thrown from Shopify for one of them*/
                            done(null)
                            //   },5000)
                        }).catch(error => {
                            done(error)
                        });

                    })
                })
            })
            console.log('functionsToCall', functionsToCall);
            async.series(functionsToCall,
                function (err, responses) {
                    if (err) {
                        return reject(err)
                    }
                    resolve()
                })
        })

    }

    searchShopifyOrder() {
        var self = this
        this.setState({pending: true});
        return this.props.makeRequest({
            all: true,
            name: this.state.currentRecord.searchText
        }, {
            "endpoint": "/shopify_orders",
        }).then(function (response) {
            console.log('response.data 1', response.data);
            self.setState({pending: false});
            if (_.size(response.data.data) && _.get(response.data.data, '0.order_number') == self.state.currentRecord.searchText) {
                return _.get(response.data.data, '0')
            } else {
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Sorry, order not found'
                })
                throw {}
            }
        }).catch(err => {
            self.setState({pending: false});
            return Promise.reject(err)
        });
    }

    searchWarehousePickupOrder() {
        console.log('searchWarehousePickupOrder');
        var self = this
        this.setState({pending: true});
        return this.props.makeRequest({
            all: true,
            searchText: _.get(this.state.currentRecord, 'SaleData.OrderID', 'order id n/a')
        }, {
            "endpoint": "/orders",
        }).then(function (response) {
            return _.find(response.data.data, item => {
                return _.get(item, 'CustomData.OrderID') == _.get(self.state.currentRecord, 'SaleData.OrderID', 'order id n/a')
            })
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    addWarehousePickupOrder(dataToSave) {
        return new Promise((resolve, reject) => {
            console.log('dataToSave', dataToSave);
            var self = this
            var shippingAddressPhoneNumber
            if (_.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.phone')) {
                shippingAddressPhoneNumber = _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.phone', '').replace(/[^0-9.]/g, "")
                if (shippingAddressPhoneNumber.indexOf('1') === 0) { /* remove country code 1 from the phone number */
                    shippingAddressPhoneNumber = shippingAddressPhoneNumber.substring(1);
                }

            }
            var dataToUpdate = {
                CreatedFrom: 'admin',
                Status: 'Pending',
                Type: 'WarehousePickup',
                Description: 'Warehouse pickup order ',
                ProductsToAdd: dataToSave.ProductsToAdd,
                MarketName: _.get(this.searchBox, 'state.filterOptions.Market'),
                ShopifyCustomerID: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.id'),
                ShippingAddressPhoneNumber: shippingAddressPhoneNumber,
                'CustomData': {
                    OrderCreateDate: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.created_at'),
                    OrderNumber: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.order_number'),
                    OrderID: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.id', '').toString(),
                }
            }

            this.props.makeRequest(dataToUpdate, {
                "endpoint": "/orders",
                "type": 'post'
            }).then(function (response) {
                resolve()
            }).catch(err => {
                reject(err)
            });
        })
    }

    updateWarehousePickupOrder(warehousePickupOrder, dataToUpdate) {
        return new Promise((resolve, reject) => {
            console.log('updateWarehousePickupOrder');

            this.props.makeRequest(dataToUpdate, {
                "endpoint": "/orders" + '/' + encodeURIComponent(warehousePickupOrder._id),
                "type": 'patch'
            }).then(function (response) {
                console.log('before resolve');
                resolve()
            }).catch(err => {
                reject(err)
            });
        })
    }

    createVehoOrder() {
        var self = this
        this.setState({pending: true});
        var methodData = {
            type: 'post',
            "endpoint": "/veho_orders",
            messageCode: 'Veho order created'
        };
        if (_.find(_.get(this.state.currentRecord, 'selectedPackages', []), selectedPackage => {
                return !_.size(selectedPackage.packageProducts)
            })) {
            this.setState({pending: false});

            self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, add products to a package or remove it'
            })
            return Promise.reject()
        }
        var phoneNumbers = [
            _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.phone', ''),
            _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.billing_address.phone', ''),
            _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.customer.phone', ''),
            _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_lines.0.phone', ''),
            _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.phone', '')
        ]
        var phoneNumber = false
        _.forEach(phoneNumbers, number => {
            if (phoneNumber) {
                return false
            }
            if (number) {
                number = number.replace(/[^0-9.]/g, "")
                if (number.indexOf('1') === 0) { /* remove country code 1 from the phone number */
                    number = number.substring(1);
                }
                if (number.length == 10) {
                    phoneNumber = number
                }
            }
        })
        if (!phoneNumber) {
            phoneNumber = '222'
            // self.props.displayMessage({
            //     'messageType': 'warning',
            //     'messageCode': 'Valid phone number is not available in Shopify order'
            // })
            // return Promise.reject()
        }

        var shippingAddress = _.get(this.state.currentRecord, 'OrdersData.0.orderShippingAddress', {})


        var packagesWithExtraData = _.map(_.get(this.state.currentRecord, 'selectedPackages', []), item => {
            var  TransactionIDs = []
            _.forEach(item.packageProducts, packageProduct =>{
                    if (_.size(_.get(packageProduct,'AllProductTransactions',[]))){
                        _.forEach(_.get(packageProduct,'AllProductTransactions',[]), transaction => {
                             TransactionIDs.push(_.get(transaction, '_id'))
                        })
                    }else {
                        TransactionIDs.push(_.get(packageProduct, 'Transaction._id'))
                    }
                })
           return {
                "externalId": _.map(item.packageProducts, 'product_id').join(','),
                // packageProducts:item.packageProducts,
                "height": item.value[0],
                "width": item.value[1],
                "length": item.value[2],
                "declaredValue": 5000,
                packageDimensions: item.value[0] + ' x ' + item.value[1] + ' x ' + item.value[2],
                "weight": 10,
                TransactionIDs: TransactionIDs,
                "description": _.map(item.packageProducts, 'title').join(', '),
                packageProductsData: _.map(item.packageProducts, product => {
                    return {product_id: product.product_id, title: product.title}
                })
            }
        })
        var VehoOrderData =
            {

                "destination": {
                    "street": _.get(shippingAddress, 'address1', ''),
                    "appartment": _.get(shippingAddress, 'address2', ''),

                    "city": _.get(shippingAddress, 'city', ''),
                    "state": _.get(shippingAddress, 'province_code', ''),
                    "zipCode":_.get(shippingAddress, 'zip','').length > 5 ? _.get(_.get(shippingAddress, 'zip').match(/^\d{5}/), 0, 'zip code not correct') : _.get(shippingAddress, 'zip'),
                },
                "recipient": _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.first_name', 'n/a') + ' ' + _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.shipping_address.last_name'),

                "company": _.map(_.get(this.state.currentRecord, 'OrdersData'), item => {
                    return _.get(item, 'ShopifyOrder.order_number', '')
                }).join(','),
                "phone": phoneNumber,
                "externalId": _.map(_.get(this.state.currentRecord, 'OrdersData'), item => {
                    return _.get(item, 'ShopifyOrder.order_number', '')
                }).join(','),
                "packages": _.map(packagesWithExtraData, item => {
                    return _.omit(item, ['packageDimensions', 'TransactionIDs', 'packageProductsData'])
                }),


            }


        return this.props.makeRequest({
            VehoOrderData: VehoOrderData,
            ShopifyOrderID: _.get(this.state.currentRecord, 'OrdersData.0.ShopifyOrder.id', ''),

        }, methodData).then(function (response) {
            return {VehoOrderData: _.get(response, 'data.orderData'), VehoOrderPackageData: packagesWithExtraData}
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    getVehoOrder() {
        var methodData = {
            type: 'patch',
            "endpoint": "/veho_orders",
        };
        return this.props.makeRequest({
            action: 'getByID',
            VehoOrderID: _.get(this.state.currentRecord, 'VehoOrderID')
        }, methodData).then(function (response) {
            return response
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    cancelVehoOrder() {
        var methodData = {
            type: 'patch',
            "endpoint": "/veho_orders",
            messageCode: 'Veho order cancelled'
        };
        return this.props.makeRequest({
            action: 'cancel',
            VehoOrderID: _.get(this.state.currentRecord, 'VehoOrderID')
        }, methodData).then(function (response) {
            return response
        }).catch(err => {
            return Promise.reject(err)
        });
    }

    displayOrderProducts(orderData) {
        return <div style={{maxHeight: 200, overflowX: 'hidden'}} className='top20'>
            {this.state.currentScreen == 'AddOrderDetailScreen' &&
            <div className="bot10">Select items for { _.get(this.state, 'selectedOrderType', '').toLowerCase()}</div>
            }

            {_.map(_.get(orderData, 'OrderProducts', []), (item, index) => {
                    if (this.state.currentScreen == 'UpdateConnectedTransactionsScreen') {
                        if (_.get(this.state, 'currentRecord.connectedOrdersAction') == 'combine') {
                            if (_.size(_.get(item, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                                if (_.find(_.get(item, 'ConnectedTransactionsData.ConnectedTransactions', []), connectedTransactionData => {
                                        return _.includes(_.get(connectedTransactionData, 'Transactions', []), _.get(item, 'Transaction._id'))
                                    })) {
                                    return null
                                    /*do not display transaction if it is already connected*/
                                }

                            }
                        } else if (_.get(this.state, 'currentRecord.connectedOrdersAction') == 'uncombine') {
                            console.log('uncombine');
                            if (!_.includes(orderData.ConnectedOrderTransactions, _.get(item, 'Transaction._id'))) {
                                return null
                                /*  display only transactions related to this connection*/
                            }
                        }

                    } else {

                        if (_.size(_.get(orderData, 'ConnectedOrderTransactions', []))) {
                            if (!_.includes(orderData.ConnectedOrderTransactions, _.get(item, 'Transaction._id'))) {
                                return null
                                /*  display only transactions related to this connection*/
                            }
                        } else {

                            if (_.size(_.get(item, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                                if (_.find(_.get(item, 'ConnectedTransactionsData.ConnectedTransactions', []), connectedTransactionData => {
                                        return _.includes(_.get(connectedTransactionData, 'Transactions', []), _.get(item, 'Transaction._id'))
                                    })) {
                                    return null
                                    /*do not display transaction if it is already connected*/
                                }
                            }
                        }
                    }


                    var foundProductIndex = false, checkBoxSelected = false
                    if (this.state.currentScreen == 'AddOrderDetailScreen') {
                         foundProductIndex = _.findIndex(_.get(this.state.currentRecord, 'selectedProducts', []), addedProduct => {
                             return addedProduct.id == item.id
                        })
                    }
                    var productAddedToPackage = _.find(_.get(this.state.currentRecord, 'selectedPackages', []), selectedPackage => {
                        return _.find(selectedPackage.packageProducts, addedProduct => {
                            return addedProduct.id == item.id
                        })
                    })
                    var message = false, checkBoxDisabled = false

                    if (_.get(this.searchBox, 'state.filterOptions.Market')) {
                        var MarketNameToCheck =_.get(config.warehouseData[_.get(item, 'Transaction.MarketName')],'FulfillmentCenter', _.get(item, 'Transaction.MarketName', ''))
                        if (MarketNameToCheck !== _.get(this.searchBox, 'state.filterOptions.Market')) {
                            message = _.get(item, 'Transaction.MarketName', '') + ' Location'
                            checkBoxDisabled = true;
                        }
                    } else {

                    }
                    if (_.get(item, 'Transaction.Status') !== 'Pending') {
                        checkBoxDisabled = true;
                        message = 'Item in "' + _.get(item, 'Transaction.Status') + '" status'
                    }
                    if (_.get(item, 'Transaction.FulfilledAt')) {
                        checkBoxDisabled = true;
                        message = 'Item Fulfilled'
                    }

                    if (this.state.currentScreen == 'AddOrderDetailScreen' && _.get(item, 'Transaction.SaleData.OrderShippingType', '') == (this.state.selectedOrderType)) {
                        message = 'Transaction already set as ' + _.get(item, 'Transaction.SaleData.OrderShippingType', '')
                        checkBoxDisabled = true;
                    }
                    if (!_.get(item, 'Transaction._id')) {
                        checkBoxDisabled = true;
                        message = 'Transaction not found for Shopify product'
                    }

                    if (this.state.currentRecord.changeShippingTypeToPickup || this.state.currentScreen == 'VehoScreen') {
                        checkBoxSelected = productAddedToPackage ? true : false
                        if (productAddedToPackage && productAddedToPackage.id !== this.state.currentRecord.currentSelectedPackageID) {
                            checkBoxDisabled = true
                        }
                    } else if (_.get(this.state, 'currentRecord.connectedOrdersAction') == 'combine' || this.state.currentScreen == 'RemoveClaimsForTransactions') {
                        checkBoxSelected = _.findIndex(_.get(this.state.currentRecord, 'selectedTransactions', []), orderToCombine => {
                            return orderToCombine.TransactionID == _.get(item, 'Transaction._id')
                        }) == -1 ? false : true
                    }
                     if (this.state.currentScreen == 'RemoveClaimsForTransactions') {
                        checkBoxDisabled = false
                        message = ''
                        if (!( _.get(item, 'Transaction.SaleData.ClaimedByUserID') && moment().diff(moment(_.get(item, 'Transaction.SaleData.ClaimedByUserAt')), 'minutes') < 120)) {
                            checkBoxDisabled = true
                            message = 'not_available'
                        }
                    }
                    return <Row key={index} style={_.extend({
                        marginLeft: 0,
                        marginRight: 0, marginBottom: 10,
                    }, message ? {
                        border: '1px solid red', opacity: 0.5
                    } : {}) }>
                        {message &&
                        <div className="font-size-19" style={{color: 'red', textAlign: 'center'}}>
                            {message == 'not_available' ? '' : message}
                        </div>
                        }
                        <div style={{display: 'flex'}}>

                            { (this.state.currentRecord.changeShippingTypeToPickup || _.includes(['VehoScreen', 'RemoveClaimsForTransactions'], this.state.currentScreen) || _.get(this.state, 'currentRecord.connectedOrdersAction') == 'combine' ) &&
                            <div style={{alignSelf: 'center'}} className="pull-left left8 ">

                                <Checkbox style={{}}
                                          disabled={checkBoxDisabled  }
                                          onClick={(e) => {
                                               if (_.get(this.state, 'currentRecord.connectedOrdersAction') == 'combine' || _.includes(['RemoveClaimsForTransactions'], this.state.currentScreen)) {
                                                  var foundTransactionIndex = _.findIndex(_.get(this.state.currentRecord, 'selectedTransactions', []), orderToCombine => {
                                                      return orderToCombine.TransactionID == _.get(item, 'Transaction._id')
                                                  })
                                                   if (foundTransactionIndex == -1) {
                                                      var AllProductTransactions = [] /* get transactions related to the selected product, one product can have several transactions*/
                                                      if(item.quantity>1){
                                                          AllProductTransactions = _.filter(_.get(orderData, 'OrderTransactions', []), orderTransaction => {
                                                              return  _.get(orderTransaction, 'ProductID.ShopifyProductID') == item.product_id
                                                          })
                                                      }

                                                      console.log('AllProductTransactions', AllProductTransactions  );
                                                      var selectedTransactions = _.concat(_.get(this.state.currentRecord, 'selectedTransactions', []), [{
                                                          OrderID: _.get(item, 'Transaction.SaleData.OrderID'),
                                                          OrderNumber: _.get(item, 'Transaction.SaleData.OrderNumber'),
                                                          TransactionID: _.get(item, 'Transaction._id'),
                                                          SaleData: (item.Transaction || {}).SaleData || {},
                                                          ProductID:_.get(item, 'Transaction.ProductID._id'),
                                                          TransactionMarketName:_.get(item, 'Transaction.MarketName'),
                                                          AllProductTransactions:AllProductTransactions
                                                      }])
                                                  } else {
                                                      var selectedTransactions = [...this.state.currentRecord.selectedTransactions.slice(0, foundTransactionIndex),
                                                          ...this.state.currentRecord.selectedTransactions.slice(foundTransactionIndex + 1)]
                                                  }
                                                  console.log('selectedTransactions', selectedTransactions  );
                                                  this.setState({
                                                      'currentRecord': {
                                                          ...this.state.currentRecord,
                                                          selectedTransactions: selectedTransactions
                                                      }
                                                  })
                                              } else { /* select products for Veho package*/
                                                   var currentSelectedPackageIndex = _.findIndex(_.get(this.state.currentRecord, 'selectedPackages', []), selectedPackage => {
                                                      return selectedPackage.id == _.get(this.state.currentRecord, 'currentSelectedPackageID')
                                                  })
                                                  console.log('currentSelectedPackageIndex', currentSelectedPackageIndex  );
                                                  if (currentSelectedPackageIndex == -1) {
                                                      e.preventDefault()
                                                      return this.props.displayMessage({
                                                          'messageType': 'warning',
                                                          'messageCode': 'Please, select a package for this product'
                                                      });
                                                  }
                                                  var selectedPackageCopy = {...this.state.currentRecord.selectedPackages[currentSelectedPackageIndex]}
                                                  var foundProductIndex = _.findIndex(selectedPackageCopy.packageProducts, addedProduct => {
                                                      return addedProduct.id == item.id
                                                  })
                                                   var AllProductTransactions = []
                                                   if(item.quantity>1){
                                                       AllProductTransactions = _.filter(_.get(orderData, 'OrderTransactions', []), orderTransaction => {
                                                           return  _.get(orderTransaction, 'ProductID.ShopifyProductID') == item.product_id
                                                       })
                                                   }
                                                   console.log('AllProductTransactions', AllProductTransactions  );
                                                  if (foundProductIndex == -1) {
                                                      selectedPackageCopy.packageProducts.push({...item,AllProductTransactions:AllProductTransactions})
                                                  } else {
                                                      _.pullAt(selectedPackageCopy.packageProducts, [foundProductIndex])
                                                  }

                                                  this.setState({
                                                      'currentRecord': {
                                                          ...this.state.currentRecord,
                                                          selectedPackages: [...this.state.currentRecord.selectedPackages.slice(0, currentSelectedPackageIndex),
                                                              selectedPackageCopy,
                                                              ...this.state.currentRecord.selectedPackages.slice(currentSelectedPackageIndex + 1)],
                                                      }
                                                  })
                                              }
                                          }}
                                          checked={ checkBoxSelected }></Checkbox>
                            </div>
                            }



                            {this.state.currentScreen == 'AddOrderDetailScreen' &&
                            <div style={{alignSelf: 'center'}} className="pull-left left8 ">

                                <Checkbox style={{}}
                                          disabled={checkBoxDisabled}
                                          onClick={(e) => {
                                              console.log('foundProductIndex', foundProductIndex);

                                              if (foundProductIndex == -1) {
                                                  var AllProductTransactions = []
                                                  if(item.quantity>1){
                                                      AllProductTransactions = _.filter(_.get(orderData, 'OrderTransactions', []), orderTransaction => {
                                                          return  _.get(orderTransaction, 'ProductID.ShopifyProductID') == item.product_id
                                                      })
                                                  }
                                                  console.log('2 AllProductTransactions', AllProductTransactions  );
                                                  var dataToUpdate = _.concat(..._.get(this.state.currentRecord, 'selectedProducts', []), [{...item,AllProductTransactions:AllProductTransactions}])
                                              } else {
                                                  var dataToUpdate = [..._.get(this.state.currentRecord, 'selectedProducts', []).slice(0, foundProductIndex),
                                                      ..._.get(this.state.currentRecord, 'selectedProducts', []).slice(foundProductIndex + 1)]
                                              }
                                              console.log('dataToUpdate', foundProductIndex, dataToUpdate);

                                              this.setState({
                                                  'currentRecord': {
                                                      ...this.state.currentRecord,
                                                      selectedProducts: dataToUpdate,
                                                  }
                                              })
                                          }}
                                          checked={ foundProductIndex !== -1 }></Checkbox>
                            </div>
                            }

                            <Col style={{position: 'relative'}} className="pull-left pbot20" sm={6} md={2} lg={2}>

                                <img style={{marginTop: 10}} width="60px" height="60px"
                                     src={formatImageForBucket(_.get(item, 'Transaction.ProductID.OriginalImages.0.URL', '')) }/>
                                <span style={{
                                    backgroundColor: '#919EAC', color: 'white',
                                    'padding': '3px 11px', 'border-radius': 14, right: 4, position: 'absolute', top: 0
                                }}>{item.quantity}</span>
                            </Col>
                            <Col className="top4" sm={12} md={6} lg={6}>
                                <ControlLabel
                                    className="purple">{_.get(item, 'Transaction.ProductID.ProductName', '')}</ControlLabel>
                                <div className="bot5 darkGray">SKU: { _.get(item, 'Transaction.ProductID.SKU', '')}</div>
                                {_.get(item, 'Transaction.SaleData.ShopifyOrderNote', '') &&
                                <div className="pbot20 pink">
                                    Note: { _.get(item, 'Transaction.SaleData.ShopifyOrderNote', '')}</div>
                                }
                                { _.includes(['EditWorkWavePlanningScreen' ,'EditScheduledDeliveriesScreen',"EditShippingScreen"], this.state.currentScreen) &&
                                <div style={{alignSelf: 'center'}} className="bot10 "> 

                                    {this.displayChangeStatusFieldForProduct(item)}
                                </div>
                                }
                            </Col>

                        </div>
                        {productAddedToPackage &&
                        <div className="left10">{productAddedToPackage.label}</div>
                        }
                    </Row>
                }
            )}
        </div>
    }

    displaySelectedPackagesToProductsMap() {
        return <div className='top20'>
            {_.map(_.get(this.state.currentRecord, 'selectedPackages', []), (item, index) => {
                    return <Row key={index}>
                        <Col className="top4" sm={12} md={6} lg={6}>
                            <Checkbox style={{}}
                                      onClick={() => {
                                          this.setState({
                                              'currentRecord': {
                                                  ...this.state.currentRecord,
                                                  currentSelectedPackageID: this.state.currentRecord.currentSelectedPackageID == item.id ? false : item.id,
                                              }
                                          })
                                      }}
                                      checked={this.state.currentRecord.currentSelectedPackageID == item.id  }>
                                <div>{item.label}</div>
                                <div>{'(H:' + item.value[0] + ' W:' + item.value[1] + ' L:' + item.value[2] + ')'}</div>
                            </Checkbox>

                        </Col>

                        <Col className="top16" sm={12} md={6} lg={6}>
                            {_.map(item.packageProducts, selectedProduct => {
                                return selectedProduct.title
                            }).join(', ')}
                        </Col>

                    </Row>

                }
            )}
        </div>
    }

    displayOrderDataAndProducts(orderData) {

        return <div>
            {_.map(_.get(this.state.currentRecord, 'OrdersData', []), (orderData, index) => {

                return <div key={orderData.orderID} className="top30 bot30">
                    <Row>
                        <Col xs={3} sm={3} md={3} lg={3} className="top10">
                    <span
                        className="text-bold purple">Order#</span><span>{ ' ' + _.get(orderData, 'OrderTransactions.0.SaleData.OrderNumber', '') }</span>
                        </Col>


                        <Col xs={5} sm={5} md={5} lg={5} className="pull-right   top10">
                    <span className="pull-right"><span
                        className=" purple text-bold"> Order Date </span><span > {moment(_.get(orderData, 'OrderTransactions.0.createdAt')).format('MM/DD')}</span></span>
                        </Col>
                        {_.size(_.get(orderData, 'OrderProducts', [])) > 0 &&
                        <Col className="font-size-19" style={{}} xs={12}>
                            {this.displayOrderProducts(orderData)}

                        </Col>
                        }
                    </Row>


                </div>

            })}


        </div>
    }

    render() {
//console.log('this.state', this.state  );

        return (
            <div className="fullfillment-page">
                <AdminFulfillmentSearchBox pending={this.state.pending}
                                           ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            this.search({page:this.state.currentPage+1})
                        }
                    } }
                    currentTab={this.state.currentTab}
                    addOrder={this.addOrder.bind(this)}
                    changeTab={this.changeTab.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} >
                </AdminFulfillmentSearchBox>

                <div className="clearfix"></div>
                {this.state.adminFulfillment.fetched &&
                <div className="">
                    {this.state.adminFulfillment.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">
                            {this.state.currentTab === 'DeliverySchedule' &&
                            <AdminFulfillmentListTable
                                searchBoxReference={this.searchBox}
                                tableData={this.state.adminFulfillment.data}
                                onSortChange={this.onSortChange.bind(this)}
                                changeTab={this.changeTab.bind(this)}
                                currentTab={this.state.currentTab}
                                prepareMultipleOrdersScreen={this.prepareMultipleOrdersScreen.bind(this)}
                                search={this.search.bind(this)} {...this.props}>
                            </AdminFulfillmentListTable>}

                            {this.state.currentTab === 'WorkWavePlanning' &&
                            <AdminWorkwavePlanningTable
                                searchBoxReference={this.searchBox}
                                tableData={this.state.adminFulfillment.data}
                                onSortChange={this.onSortChange.bind(this)}
                                changeTab={this.changeTab.bind(this)}
                                currentTab={this.state.currentTab}
                                prepareMultipleOrdersScreen={this.prepareMultipleOrdersScreen.bind(this)}
                                search={this.search.bind(this)} {...this.props}>
                            </AdminWorkwavePlanningTable> }
                            {this.state.currentTab === 'ScheduledDeliveries' &&
                            <AdminScheduledDeliveriesTable
                                searchBoxReference={this.searchBox}
                                tableData={this.state.adminFulfillment.data}
                                onSortChange={this.onSortChange.bind(this)}
                                changeTab={this.changeTab.bind(this)}
                                currentTab={this.state.currentTab}
                                prepareMultipleOrdersScreen={this.prepareMultipleOrdersScreen.bind(this)}
                                search={this.search.bind(this)} {...this.props}>
                            </AdminScheduledDeliveriesTable> }
                            {this.state.currentTab === 'Shipping' &&
                            <AdminShippingTable
                                searchBoxReference={this.searchBox}
                                tableData={this.state.adminFulfillment.data}
                                onSortChange={this.onSortChange.bind(this)}
                                changeTab={this.changeTab.bind(this)}
                                currentTab={this.state.currentTab}

                                prepareMultipleOrdersScreen={this.prepareMultipleOrdersScreen.bind(this)}
                                search={this.search.bind(this)} {...this.props}>
                            </AdminShippingTable> }
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={  this.state.adminFulfillment.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>
                        </div>}
                        {this.state.pending &&
                        <div className="pending-box"></div>
                        }

                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{ typeof _.get(screenDataMap, [this.state.currentScreen, 'title'], '') == "function" ? screenDataMap[this.state.currentScreen].title(this.state) : _.get(screenDataMap, [this.state.currentScreen, 'title'], '') }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {  !_.includes(['CreateOrderConfirmationScreen','PrintFedExLabelScreen','FulfillFedExOrderScreen','AddOrderScreen', 'RemoveClaimsForTransactions', 'UpdateConnectedTransactionsScreen'], this.state.currentScreen) && this.displayOrderDataAndProducts(this.state.currentRecord)}
                        {this.displayCurrentScreenContent()}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        metroAreas: state.metroAreas,
        vehoZipCodes: state.vehoZipCodes,
        userReducer: state.userReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminFulfillmentPage);
